<template>
    <div>
        <v-dialog v-model="dialog" max-width="900" persistent>
            <v-card>
                <v-container>
                    <v-card-title> <span class="overline font-weight-black">カラーパース依頼内容</span> 
                        <v-spacer></v-spacer>
                        <v-icon dark @click="toggleDialogColorPerspective(false)">mdi-close</v-icon>
                    </v-card-title>
                        <v-container>
                            <v-stepper v-model="e6" vertical >
                                <v-container>
                                    <!-- Step 1 -->
                                    <template>
                                        <v-stepper-step :complete="e6 > 1" step="1" color="#455a64">
                                            <span class="caption font-weight-black">色を選択してください</span>
                                            <small class="caption">{{radio}}</small>
                                        </v-stepper-step>

                                        <v-stepper-content step="1">
                                            <v-radio-group v-model="$store.state.radio" dense>
                                                <template v-for="(requestContent, i) in requestContents">
                                                    <v-radio
                                                        :key="i"
                                                        :label="requestContent.text" 
                                                        :value="requestContent.text"
                                                        class="mb-n1"
                                                        :disabled="requestContent.text == '色情報を指示して依頼' && $store.state.finalPlanSiyo == 1"
                                                        @click="proceedToNext()"
                                                    ></v-radio>
                                                    <p :key="i+'A'" class="caption pl-8 red--text mb-3">
                                                        {{ requestContent.desc }}
                                                    </p>
                                                </template>
                                            </v-radio-group>
                                            <template>
                                                <v-spacer></v-spacer>
                                                <!-- <v-btn color="#455a64" small class="white--text" @click="proceedToNext()" :disabled="!$store.state.radio"> 継続する </v-btn> -->
                                            </template> 
                                        </v-stepper-content>
                                    </template>

                                    <!-- Step 2 -->
                                    <template>
                                        <v-stepper-step :complete="e6 > 2" step="2" color="#455a64">
                                            <span class="caption font-weight-black">依頼パターン数を入力してください</span>
                                            <small class="caption">{{requestPattern}}</small>
                                        </v-stepper-step>
                                        <v-stepper-content step="2">
                                            <v-container>
                                                <v-autocomplete
                                                    v-model="requestPattern" dense
                                                    outlined :items="[1, 2, 3, 4]"
                                                    @change="insertingColorPersContent(),radio == '色情報を指示して依頼' ? dialogColorPers = true : openDialogColorPers()"
                                                    clearable>
                                                </v-autocomplete>
                                            </v-container>
                                            <!-- <template>
                                                <v-spacer></v-spacer>
                                                <v-btn dark color="red" small @click="e6--">
                                                    Cancel
                                                    キャンセル
                                                </v-btn>
                                                <v-btn
                                                    color="#455a64" small class="white--text"
                                                    @click=" radio == '色情報を指示して依頼' ? dialogColorPers = true : openDialogColorPers()" :disabled="!requestPattern"
                                                >
                                                    継続する
                                                </v-btn>
                                            </template> -->
                                        </v-stepper-content>
                                    </template>

                                    <template>
                                        <v-stepper-step :complete="e6 > 3" step="3" color="#455a64">
                                            <span class="caption font-weight-black">カラーパース依頼書 </span>
                                        </v-stepper-step>
                                        <v-stepper-content step="3">
                                            <template v-if="radio == '仕様書に従って作成'">
                                                <v-row>
                                                    <v-col cols="8">
                                                        <v-simple-table class="mainTable colorView">
                                                            <thead>
                                                            <tr>
                                                                <th style="width: 50px !important; text-align: left !important">  </th>
                                                                <th v-for="(count, i ) in requestPattern" :key="i">
                                                                    {{ `パ一タン - ${count}` }}
                                                                </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <th style="width: 50px !important; text-align: left !important">視点方向: </th>
                                                                <td v-for="(count, i ) in requestPattern" :key="i"> 
                                                                    <v-edit-dialog
                                                                        :return-value.sync="patterns[count]">
                                                                    <!-- @open="clickIt(item)"
                                                                        @save="UpdateDataIndi('details',toEdit.details, item)"
                                                                        @close="closeIT()" -->
                                                                        <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on }">
                                                                                    <span v-on="on"> {{ patterns[count].direction }} </span>
                                                                                </template>
                                                                                <span> {{patterns[count].direction}} </span>
                                                                            </v-tooltip>
                                                                        <template v-slot:input >
                                                                        <small class="overline" > 視点方向  </small>
                                                                            <v-autocomplete
                                                                                v-model="patterns[count].direction"
                                                                                name="details"
                                                                                outlined
                                                                                dense
                                                                                rows="2"
                                                                                :items="VIEW_DIRECTION_SELECTIONS"
                                                                                item-text="direction"
                                                                                item-value="direction"
                                                                            ></v-autocomplete>
                                                                            <!-- :items="VIEW_DIRECTION_SELECTIONS" -->
                                                                        </template>
                                                                    </v-edit-dialog>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                    <th style="width: 50px !important; text-align: left !important">視点高さ: </th>
                                                                    <td v-for="(count, i ) in requestPattern" :key="i">
                                                                        <v-edit-dialog>
                                                                            <v-tooltip bottom>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <span v-on="on"> {{ patterns[count].height }} </span>
                                                                                    </template>
                                                                                    <span> {{ patterns[count].height }} </span>
                                                                                </v-tooltip>
                                                                            <template v-slot:input >
                                                                            <small class="overline" > 視点高さ </small>
                                                                                <v-autocomplete
                                                                                    v-model="patterns[count].height"
                                                                                    name="details"
                                                                                    outlined
                                                                                    dense
                                                                                    rows="2"
                                                                                    :items="VIEW_HEIGHT_SELECTIONS"
                                                                                    item-text="view_height_name"
                                                                                    item-value="view_height_name"
                                                                                ></v-autocomplete>
                                                                                    <!-- :items="VIEW_HEIGHT_SELECTIONS" -->

                                                                            </template>
                                                                        </v-edit-dialog>
                                                                    </td>
                                                            </tr>
                                                            </tbody>
                                                        </v-simple-table>
                                                        <!-- <div class="pt-8">
                                                            <v-spacer></v-spacer>
                                                            <v-btn dark color="red" small @click="e6--">
                                                                Cancel
                                                                キャンセル
                                                            </v-btn>
                                                            <v-btn
                                                                color="#455a64" small class="white--text"
                                                                @click="storeData()">
                                                                継続する
                                                            </v-btn>
                                                        </div> -->
                                                    </v-col>
                                                    <v-col cols="4">
                                                        <v-img
                                                        lazy-src
                                                        contain
                                                        src="img/view.png"
                                                        alt="view.png"
                                                        ></v-img>
                                                    </v-col>
                                                </v-row>
                                            </template>

                                            <!-- <template v-else> 
                                                <span class="caption"> Work In Progress </span> 
                                                <v-btn text small @click="e6--">
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    color="#455a64" small class="white--text"
                                                >
                                                    継続する
                                                </v-btn>
                                            </template> -->
                                        </v-stepper-content>
                                    </template>

                                    <!-- step 4 -->
                                    
                                    <!-- <template>
                                        <v-stepper-step step="4" color="#455a64">
                                            Lorem Ipsum
                                        </v-stepper-step>
                                        <v-stepper-content step="4">
                                            <v-card
                                                color="grey lighten-1"
                                                class="mb-12"
                                                height="200px"
                                            ></v-card>
                                            <template>
                                                <v-spacer></v-spacer>
                                                <v-btn text small @click="e6--">
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    color="#455a64" small class="white--text"
                                                    @click="e6 = 1" 
                                                >
                                                    継続する
                                                </v-btn>
                                            </template>
                                        </v-stepper-content>
                                    </template> -->
                                </v-container>
                            </v-stepper>
                        </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- <v-btn text type="submit" @click="dialogColorPers = false">Submit</v-btn> -->
                        <!-- <v-btn dark color="red" v-show="!editMode" @click="toggleDialogColorPerspective(false)">キャンセル</v-btn> -->
                        <v-btn dark color="success" medium v-show="e6 == 3" @click="storeData()" style="width:10%;">保存</v-btn>
                        <v-btn dark color="red" medium @click="e6--" v-show="e6 == 2 || e6 == 3" style="width:10%;">戻る</v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogColorPers"
            persistent
            max-width="2000"
            width="1300">
            <v-card>
                <v-card-title>
                    <span class="headline">カラーパース依頼書</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="dialogColorPers = false" dark>mdi-close</v-icon>
                </v-card-title>
                <v-container fluid>
                    <v-card-text>
                        <v-container fluid>
                            <v-simple-table class="requestView " fixed-header height="75vh">
                                <thead>
                                    <tr></tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(header, i) in colorPersRequestHeaders" :key="i" class="text-center">
                                        <th colspan="2" class="left-sticky" style="width: 100px !important;max-width: 100px !important;font-size:22px !important; height: 100px !important; background-color: #D3D3D3 !important" v-if="header == '依頼日'">
                                            <p class="h1 font-weight-black mx-2">{{ header }}</p> 
                                        </th>
                                        
                                        <template  v-else-if="header == '視点方向' || header == '視点高さ' ">
                                            <th colspan="1" class="left-sticky" style="width: 100px !important;max-width: 100px !important;font-size:20px !important; height: 50px !important; background-color: #D3D3D3 !important">
                                                <p class="h1 font-weight-black mx-2">{{ header }}</p> 
                                            </th>

                                            <th style="width: 100px !important;max-width: 100px !important;font-size:20px !important; background-color: #D3D3D3 !important" colspan="1" rowspan="2" class="image-header-sticky"  v-if="header == '視点方向' ">
                                                <v-img
                                                    height="150"
                                                    width="150"
                                                    lazy-src
                                                    contain
                                                    src="img/view.png"
                                                    alt="view.png"
                                                ></v-img>
                                            </th>
                                        </template>

                                        <th colspan="2" class="left-sticky" style="width: 100px !important;max-width: 100px !important;font-size:20px !important; height: 50px !important; background-color: #D3D3D3 !important" v-else>
                                            <p class="h1 font-weight-black mx-2">{{ header }}</p> 
                                        </th>
                                        <!-- SECTION RECENT -->
                                            <template v-for="(color, iii) in existingColorPers" >
                                                <template>
                                                    <td  style="width: 100px; !important" :key="iii" :class="`pattern-${requestPattern}-${color}`" v-if="header == '依頼日'">
                                                        <p class="overline mx-2">パターン{{iii+1}} <br> {{color.temp_created}}</p>
                                                    </td>
                                                    <td :key="iii" :class="`pattern-${requestPattern}-${color}`" v-if="header == '図面番号'">
                                                            {{ color.revision }}
                                                    </td>
                                                    <td :key="iii" :class="`pattern-${requestPattern}-${color}`" v-if="header == '建物タイプ'">
                                                        <v-autocomplete readonly
                                                            v-model="color.house_type_id"
                                                            :items="HOUSE_TYPES"
                                                            item-text="name"
                                                            item-value="id"
                                                        >
                                                        </v-autocomplete>
                                                        <!-- {{ color.house_type_id }} -->
                                                    </td>

                                                    <!--td 屋根 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '屋根'">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on"  :class="`pattern-${requestPattern}-${color}`" style="cursor: pointer">
                                                                {{color.roof}}
                                                            </td>
                                                        </template>
                                                        <span class="overline">屋根</span>
                                                    </v-tooltip>

                                                    <!--td 吹付け(1F) -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '吹付け(1F)'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                {{color.spray_1f}}
                                                            </td>
                                                        </template>
                                                        <span class="overline">吹付け(1F)</span>
                                                    </v-tooltip>

                                                    <!--td 吹付け(2F) -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '吹付け(2F)'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                {{color.spray_2f}}
                                                                
                                                            </td>
                                                        </template>
                                                        <span class="overline">吹付け(2F)</span>
                                                    </v-tooltip>

                                                    <!--td 吹付け(3F) -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '吹付け(3F)'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                {{color.spray_3f}}
                                                                
                                                            </td>
                                                        </template>
                                                        <span class="overline">吹付け(3F)</span>
                                                    </v-tooltip>

                                                    <!--td 外壁タイル -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '外壁タイル'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <!-- {{ color.exterior_wall_tile }} -->
                                                                <span v-if="!color.accent_wall_color">{{ color.exterior_wall_tile }}</span>
                                                                <span v-else>{{ color.exterior_wall_tile }} / {{ color.accent_wall_color }}</span>
                                                            </td>
                                                        </template>
                                                        <span class="overline">外壁タイル</span>
                                                    </v-tooltip>

                                                    <!-- 外壁仕上げ -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '外壁仕上げ'">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs" v-on="on" :class="`pattern-${requestPattern}-${color}`" style="cursor:pointer;">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly v-model="color.external_wall_finish" dense :items="TILE_EXTERNAL" item-text="external_color" item-value="external_color"> </v-combobox> -->
                                                                {{ color.external_wall_finish }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">外壁仕上げ</span>
                                                    </v-tooltip>

                                                    <!--td バルコニーガラス -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'バルコニーガラス'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly v-model="color.balcony_glass" dense :items="balconyGlass" item-text="text" item-value="value"> </v-combobox> -->
                                                                {{ color.balcony_glass }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">バルコニーガラス</span>
                                                    </v-tooltip>
                                                    
                                                    <!--td デザインルーバー -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'デザインルーバー'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                {{ color.design_louver }}
                                                            </td>
                                                        </template>
                                                        <span class="overline">デザインルーバー</span>
                                                    </v-tooltip>

                                                    <!--td サッシ -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'サッシ'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly v-model="color.sash" dense :items="SASH_SELECTION" item-text="sashSelectionName" item-value="sashSelectionCode"> </v-combobox> -->
                                                                    {{ color.sash }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">サッシ</span>
                                                    </v-tooltip>

                                                    <!--td 玄関ドア -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '玄関ドア'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <span class="required">{{color.front_door}}</span>
                                                            </td>
                                                        </template>
                                                        <span class="overline">玄関ドア</span>
                                                    </v-tooltip>

                                                    <!-- 木目調軒天 -->

                                                    <!--td モール・矢切飾り --> 
                                                    <!-- :items="mallAndArrowheadDecorationList" -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'モール・矢切飾り'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly 
                                                                        :items="MOLDING_SELECTION"
                                                                        item-value="moldingSelectionCode"
                                                                        item-text="moldingSelectionName"
                                                                        v-model="color.mall_and_arrowhead_decoration"
                                                                        dense> </v-combobox> -->
                                                                    {{ color.mall_and_arrowhead_decoration }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">モール・矢切飾り</span>
                                                    </v-tooltip>

                                                    <!--td バルコニー帯 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'バルコニー帯'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly 
                                                                        :items="BALCONY_BELT_MAKEUP_TILES"
                                                                        item-value="balcony_belt_value"
                                                                        item-text="balcony_belt_name"
                                                                        v-model="color.balcony_belt"
                                                                        dense> </v-combobox> -->
                                                                    {{ color.balcony_belt }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">バルコニー帯</span>
                                                    </v-tooltip>

                                                    <!--td タイル面帯 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'タイル面帯'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly 
                                                                        :items="BALCONY_BELT_MAKEUP_TILES"
                                                                        item-value="balcony_belt_value"
                                                                        item-text="balcony_belt_name"
                                                                        v-model="color.tile_band"
                                                                        dense> </v-combobox> -->
                                                                    {{ color.tile_band }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">タイル面帯</span>
                                                    </v-tooltip>

                                                    <!--td 化粧帯(1F) -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '化粧帯(1F)'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly 
                                                                        :items="BALCONY_BELT_MAKEUP_TILES"
                                                                        item-value="balcony_belt_value"
                                                                        item-text="balcony_belt_name"
                                                                        v-model="color.decorative_belt_1f"
                                                                        dense> </v-combobox> -->
                                                                    {{ color.decorative_belt_1f }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">化粧帯(1F)</span>
                                                    </v-tooltip>

                                                    <!--td 化粧帯(2F) -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '化粧帯(2F)'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly
                                                                        :items="BALCONY_BELT_MAKEUP_TILES"
                                                                        item-value="value"
                                                                        item-text="text"
                                                                        v-model="color.decorative_belt_2f"
                                                                        dense> </v-combobox> -->
                                                                    {{ color.decorative_belt_2f }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">化粧帯(2F)</span>
                                                    </v-tooltip>

                                                    <!--td 軒天 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '軒天'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly           
                                                                        v-model="color.eaves_of_a_house" 
                                                                        dense 
                                                                        :items="EAVES_SELECTIONS" 
                                                                        item-text="eaves_name" 
                                                                        item-value="eaves_value"> </v-combobox> -->
                                                                    {{ color.eaves_of_a_house }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">軒天</span>
                                                    </v-tooltip>

                                                    <!-- 軒樋 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '軒樋'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly           
                                                                        v-model="color.eaves_gutter" 
                                                                        dense 
                                                                        :items="EAVES_GUTTER_SELECTION" 
                                                                        item-text="name" 
                                                                        item-value="code"> </v-combobox> -->
                                                                    {{ color.eaves_gutter }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">軒樋</span>
                                                    </v-tooltip>

                                                    <!--td 破風 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '破風'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly v-model="color.breaking_wind" dense :items="GABLE_SELECTIONS" item-text="gable_name" item-value="gable_value"> </v-combobox> -->
                                                                    {{ color.breaking_wind }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">破風</span>
                                                    </v-tooltip>

                                                    <!--td 土台水切り -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '土台水切り'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-combobox readonly v-model="color.base_draining" dense :items="BASE_DRAINERS" item-text="base_drainer_name" item-value="base_drainer_value"> </v-combobox> -->
                                                                    {{ color.base_draining }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">土台水切り</span>
                                                    </v-tooltip>

                                                    <!--td ポーチタイル -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == 'ポーチタイル'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                {{ color.porch_tile}}
                                                            </td>
                                                        </template>
                                                        <span class="overline">ポーチタイル</span>
                                                    </v-tooltip>

                                                    <!--td 視点方向 -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '視点方向'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-autocomplete readonly v-model="color.perspective_direction" dense :items="VIEW_DIRECTION_SELECTIONS" item-text="direction" item-value="direction"> </v-autocomplete> -->
                                                                    {{ color.perspective_direction }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">視点方向</span>
                                                    </v-tooltip>

                                                    <!--td 視点高さ -->
                                                    <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="iii"  v-if="header == '視点高さ'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container>
                                                                    <!-- <v-autocomplete readonly v-model="color.viewpoint_height" dense :items="VIEW_HEIGHT_SELECTIONS" item-text="view_height_name" item-value="view_height_value"> </v-autocomplete> -->
                                                                    {{ color.viewpoint_height }}
                                                                </v-container>
                                                            </td>
                                                        </template>
                                                        <span class="overline">視点高さ</span>
                                                    </v-tooltip>

                                                    <!--td ガーデン番号 -->
                                                    <!-- <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii"  v-if="header == 'ガーデン番号'" >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <td  v-bind="attrs"  v-on="on" :class="`color-${requestPattern}-${color}`"  style="cursor: pointer">
                                                                <v-container> -->
                                                                    <!-- <v-autocomplete readonly  dense> </v-autocomplete> -->
                                                                    <!-- <v-select :items="options" item-value="title" v-model="gardenSelection" label="Title" class="mb-n2 ma-1" @change="StoreGarden(ii)"> -->
                                                                        <!-- <template slot="option" slot-scope="option">
                                                                            <img :src="option.cardImage" />
                                                                            {{ option.title }}
                                                                        </template> -->
                                                                        <!-- <template v-slot:selection="{item}">
                                                                            <img :src="item.cardImage" style="width:85px;" class="mr-2" />{{ item.title }}
                                                                        </template>
                                                                        <template v-slot:item="{item}">
                                                                            <img :src="item.cardImage" style="width:200px;" class="mr-2" />{{ item.title }}
                                                                        </template> -->
                                                                    <!-- </v-select>
                                                                </v-container> -->
                                                            <!-- </td>
                                                        </template>
                                                        <span class="overline">ガーデン番号</span>
                                                    </v-tooltip> -->
                                                </template>
                                            </template>
                                        <!-- !SECTION RECENT -->


                                        <template>
                                            <td class="req-divider"></td>
                                        </template>
                                        
                                        <template v-for="(pattern, ii) in requestPattern" >
                                            <!-- NEW REQUEST -->
                                            <template v-if="!editMode" >
                                            
                                                <td  style="width: 100px !important;" :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '依頼日'">
                                                    <v-btn @click="openPreviousSelection(ii)">コピー</v-btn>
                                                    <v-btn @click="setEmptySelection(ii)">仕様書に準ずる</v-btn>
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '図面番号'">
                                                        {{ cadRequestLatestRevision }}
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '建物タイプ'">
                                                    <v-autocomplete
                                                        v-model="cadRequestBasicInformation.house_type_id"
                                                        :items="HOUSE_TYPES"
                                                        item-text="name"
                                                        item-value="id"
                                                        readonly
                                                    >
                                                    </v-autocomplete>
                                                </td>

                                                <!--td 屋根 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '屋根'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleRoofDialog(ii)" v-bind="attrs"  
                                                            v-on="on"  :class="`pattern-${requestPattern}-${pattern}`" style="cursor: pointer">
                                                            {{cadRequestColorPers[ii].roof.roof_color}}
                                                        </td>
                                                        <!-- <td
                                                            v-else>
                                                            仕様書に準ずる
                                                        </td> -->
                                                    </template>
                                                    <span class="overline">屋根</span>
                                                </v-tooltip>

                                                <!--td 吹付け(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吹付け(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleOpenSidingDialog('dialogSiding1F',ii)" 
                                                            v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{cadRequestColorPers[ii].spray_1f.exteriorRequestContent}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吹付け(1F)</span>
                                                </v-tooltip>

                                                <!--td 吹付け(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吹付け(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleOpenSidingDialog('dialogSiding2F',ii)" 
                                                            v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{cadRequestColorPers[ii].spray_2f.exteriorRequestContent}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吹付け(2F)</span>
                                                </v-tooltip>

                                                <!--td 吹付け(3F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吹付け(3F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleOpenSidingDialog('dialogSiding3F',ii)" 
                                                            v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{cadRequestColorPers[ii].spray_3f.exteriorRequestContent}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吹付け(3F)</span>
                                                </v-tooltip>

                                                <!--td 外壁タイル -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '外壁タイル'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleDialogExteriorWallTiles(ii)" 
                                                            v-bind="attrs"  
                                                            v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <!-- {{ cadRequestColorPers[ii].exterior_wall_tile.color_construction }} /  -->
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">
                                                                <!-- <span v-if="cadRequestColorPers[ii].exterior_wall_tile.color_construction == '1'">
                                                                    {{ cadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }}S
                                                                </span>
                                                                <span v-else-if="cadRequestColorPers[ii].exterior_wall_tile.color_construction == '2'">
                                                                    {{ cadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }} / {{ cadRequestColorPers[ii].exterior_wall_tile.accent_wall_color }}
                                                                </span>
                                                                <span v-else>{{ cadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }}</span> -->
                                                                <span v-if="!cadRequestColorPers[ii].exterior_wall_tile.accent_wall_color"> 
                                                                    {{ cadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }}
                                                                </span>
                                                                <span v-else> 
                                                                    {{ cadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }} / {{ cadRequestColorPers[ii].exterior_wall_tile.accent_wall_color }}
                                                                </span>
                                                            </span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">外壁タイル</span>
                                                </v-tooltip>

                                                <!-- 外壁仕上げ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important" :key="ii + header" v-if="header == '外壁仕上げ'">
                                                    <template v-slot:activator="{on,attrs}">
                                                        <td :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" v-bind="attrs" v-on="on" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setTileExternal(ii, cadRequestColorPers[ii].external_wall_finish)"
                                                                    v-model="cadRequestColorPers[ii].external_wall_finish"
                                                                    dense
                                                                    :items="TILE_EXTERNAL"
                                                                    item-text="external_color" item-value="external_color">
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">外壁仕上げ</span>
                                                </v-tooltip>

                                                <!--td バルコニーガラス -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'バルコニーガラス'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                            <!-- {{ cadRequestColorPersContent }} -->
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setBalconyGlass(ii, cadRequestColorPers[ii].balcony_glass)" 
                                                                    v-model="cadRequestColorPers[ii].balcony_glass" 
                                                                    dense 
                                                                    :items="balconyGlass" 
                                                                    item-text="text" item-value="value"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">バルコニーガラス</span>
                                                </v-tooltip>
                                                
                                                <!--td デザインルーバー -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'デザインルーバー'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleDialogDesignLouvers(ii)"
                                                                v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{ cadRequestColorPers[ii].design_louver }}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">デザインルーバー</span>
                                                </v-tooltip>

                                                <!--td サッシ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'サッシ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersSash(ii,cadRequestColorPers[ii].sash)" 
                                                                    v-model="cadRequestColorPers[ii].sash" 
                                                                    dense 
                                                                    :items="SASH_SELECTION" 
                                                                    item-text="sashSelectionName" item-value="sashSelectionCode"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">サッシ</span>
                                                </v-tooltip>

                                                <!--td 玄関ドア -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '玄関ドア'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleDialogEntranceDoor(ii)" 
                                                            v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header) && $store.state.getRadio != '8'" class="required">
                                                                {{ cadRequestColorPers[ii].front_door.door_item ? cadRequestColorPers[ii].front_door.door_item + ' / ' + cadRequestColorPers[ii].front_door.door_color : cadRequestColorPers[ii].front_door.door_color }}
                                                            </span>
                                                            <span v-else-if="$store.state.getRadio == '8' && ($store.state.isHrdCpn == false || $store.state.isHrdCpn == true)">{{ cadRequestColorPers[ii].front_door.door_color }}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">玄関ドア</span>
                                                </v-tooltip>

                                                <!-- 木目調軒天 -->
                                                <!-- <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '木目調軒天'">
                                                    <template v-slot:activator="{on,attrs}">
                                                        <td
                                                            :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer"
                                                            v-bind="attrs"  
                                                            v-on="on">
                                                        </td>
                                                    </template>
                                                </v-tooltip> -->

                                                <!--td モール・矢切飾り --> 
                                                <!-- :items="mallAndArrowheadDecorationList" -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'モール・矢切飾り'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :items="MOLDING_SELECTION"
                                                                    item-value="moldingSelectionCode"
                                                                    item-text="moldingSelectionName"
                                                                    v-model="cadRequestColorPers[ii].mall_and_arrowhead_decoration"
                                                                    dense> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">モール・矢切飾り</span>
                                                </v-tooltip>

                                                <!--td バルコニー帯 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'バルコニー帯'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="cadRequestColorPers[ii].balcony_belt"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    dense> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">バルコニー帯</span>
                                                </v-tooltip>

                                                <!--td タイル面帯 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'タイル面帯'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="cadRequestColorPers[ii].tile_band"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    dense> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">タイル面帯</span>
                                                </v-tooltip>

                                                <!--td 化粧帯(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '化粧帯(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="cadRequestColorPers[ii].decorative_belt_1f"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    dense> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">化粧帯(1F)</span>
                                                </v-tooltip>

                                                <!--td 化粧帯(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '化粧帯(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="cadRequestColorPers[ii].decorative_belt_2f" 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    dense> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">化粧帯(2F)</span>
                                                </v-tooltip>

                                                <!--td 軒天 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '軒天'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox        
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"                 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersEaves(ii, cadRequestColorPers[ii].eaves_of_a_house)" 
                                                                    v-model="cadRequestColorPers[ii].eaves_of_a_house" 
                                                                    dense 
                                                                    :items="EAVES_SELECTIONS" 
                                                                    item-text="eaves_name" item-value="eaves_value"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">軒天</span>
                                                </v-tooltip>

                                                <!-- 軒樋 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '軒樋'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox      
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"                   
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersEavesGutter(ii, cadRequestColorPers[ii].eaves_gutter)" 
                                                                    v-model="cadRequestColorPers[ii].eaves_gutter" dense 
                                                                    :items="EAVES_GUTTER_SELECTION" item-text="name" item-value="code"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                            <!-- :style="cadRequestBasicInformation.house_type_id != 3 && 
                                                                        cadRequestBasicInformation.house_type_id != 29 ? 'background-color: #34495e;' : ''"  -->
                                                            <!-- :disabled="cadRequestBasicInformation.house_type_id != 3 && 
                                                                        cadRequestBasicInformation.house_type_id != 29" -->
                                                        </td>
                                                    </template>
                                                    <span class="overline">軒樋</span>
                                                </v-tooltip>


                                                <!--td 破風 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '破風'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersBreaking_wind(ii, cadRequestColorPers[ii].breaking_wind)" 
                                                                    v-model="cadRequestColorPers[ii].breaking_wind" 
                                                                    dense 
                                                                    :items="GABLE_SELECTIONS" 
                                                                    item-text="gable_name" item-value="gable_value"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">破風</span>
                                                </v-tooltip>

                                                <!--td 土台水切り -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '土台水切り'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersBase_draining(ii, cadRequestColorPers[ii].base_draining)" 
                                                                    v-model="cadRequestColorPers[ii].base_draining" 
                                                                    dense 
                                                                    :items="BASE_DRAINERS" 
                                                                    item-text="base_drainer_name" item-value="base_drainer_value"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">土台水切り</span>
                                                </v-tooltip>

                                                <!--td ポーチタイル -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'ポーチタイル'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : togglePorchTilesDialog(ii)"  
                                                            v-bind="attrs"  
                                                            v-on="on" 
                                                            :class="`pattern-${requestPattern}-${pattern}`"  
                                                            style="cursor: pointer">
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{ cadRequestColorPers[ii].porch_tile.porch_tile_item_color}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">ポーチタイル</span>
                                                </v-tooltip>

                                                <!--td 視点方向 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '視点方向'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersPerspective_direction(ii, cadRequestColorPers[ii].perspective_direction)" 
                                                                    v-model="cadRequestColorPers[ii].perspective_direction" 
                                                                    dense 
                                                                    :items="VIEW_DIRECTION_SELECTIONS" 
                                                                    item-text="direction" item-value="direction"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点方向</span>
                                                </v-tooltip>

                                                <!--td 視点高さ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '視点高さ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container>
                                                                <v-combobox 
                                                                    v-if="COLOR_PERS_RESTRICTION.includes(header)"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersViewpoint_height(ii, cadRequestColorPers[ii].viewpoint_height)" 
                                                                    v-model="cadRequestColorPers[ii].viewpoint_height" 
                                                                    dense 
                                                                    :items="VIEW_HEIGHT_SELECTIONS" 
                                                                    item-text="view_height_name" item-value="view_height_value"> 
                                                                </v-combobox>
                                                                <v-combobox 
                                                                    v-else 
                                                                    dense
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                ></v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点高さ</span>
                                                </v-tooltip>

                                                <!--td ガーデン番号 -->
                                                <!-- <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'ガーデン番号'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container> -->
                                                                <!-- <v-autocomplete  dense> </v-autocomplete> -->
                                                                <!-- <v-select :items="options" item-value="title" v-model="gardenSelection" label="Title" class="mb-n2 ma-1" @change="StoreGarden(ii)"> -->
                                                                    <!-- <template slot="option" slot-scope="option">
                                                                        <img :src="option.cardImage" />
                                                                        {{ option.title }}
                                                                    </template> -->
                                                                    <!-- <template v-slot:selection="{item}">
                                                                        <img :src="item.cardImage" style="width:85px;" class="mr-2" />{{ item.title }}
                                                                    </template>
                                                                    <template v-slot:item="{item}">
                                                                        <img :src="item.cardImage" style="width:200px;" class="mr-2" />{{ item.title }}
                                                                    </template> -->
                                                                <!-- </v-select>
                                                            </v-container> -->
                                                        <!-- </td>
                                                    </template>
                                                    <span class="overline">ガーデン番号</span>
                                                </v-tooltip> -->
                                            </template>

                                            <!-- EDIT Request -->
                                            <template v-else>
                                            
                                                <td  style="width: 100px !important;" :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '依頼日'">
                                                    <v-btn @click="openPreviousSelection(ii)">コピー</v-btn>
                                                    <v-btn @click="setEmptySelection(ii)">仕様書に準ずる</v-btn>
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '図面番号'">
                                                        {{ editRevision }}
                                                </td>
                                                <td :key="ii + header" :class="`pattern-${requestPattern}-${pattern}`" v-if="header == '建物タイプ'">
                                                    <v-autocomplete
                                                        v-model="editCadRequestRevisionContent.house_type_id"
                                                        :items="HOUSE_TYPES"
                                                        item-text="name"
                                                        item-value="id"
                                                        readonly
                                                    >
                                                    </v-autocomplete>
                                                </td>

                                                <!--td 屋根 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '屋根'">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleRoofDialog(ii)" v-bind="attrs"  v-on="on"  :class="`pattern-${requestPattern}-${pattern}`" style="cursor: pointer">
                                                            {{editCadRequestColorPers[ii].roof.roof_color}}
                                                        </td>
                                                    </template>
                                                    <span class="overline">屋根</span>
                                                </v-tooltip>

                                                <!--td 吹付け(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吹付け(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleOpenSidingDialog('dialogSiding1F',ii)" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{editCadRequestColorPers[ii].spray_1f.exteriorRequestContent}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吹付け(1F)</span>
                                                </v-tooltip>

                                                <!--td 吹付け(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吹付け(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleOpenSidingDialog('dialogSiding2F',ii)" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{editCadRequestColorPers[ii].spray_2f.exteriorRequestContent}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吹付け(2F)</span>
                                                </v-tooltip>

                                                <!--td 吹付け(3F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '吹付け(3F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleOpenSidingDialog('dialogSiding3F',ii)" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" >
                                                            <span v-if="COLOR_PERS_RESTRICTION.includes(header)">{{editCadRequestColorPers[ii].spray_3f.exteriorRequestContent}}</span>
                                                            <span v-else></span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">吹付け(3F)</span>
                                                </v-tooltip>

                                                <!--td 外壁タイル -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '外壁タイル'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleDialogExteriorWallTiles(ii)" v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <!-- {{ editCadRequestColorPers[ii].exterior_wall_tile }} -->
                                                            <span>
                                                                
                                                            </span>
                                                            <span v-if="!editCadRequestColorPers[ii].exterior_wall_tile.accent_wall_color">{{ editCadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }}</span>
                                                            <span v-else>{{ editCadRequestColorPers[ii].exterior_wall_tile.exterior_wall_tile }} / {{ editCadRequestColorPers[ii].exterior_wall_tile.accent_wall_color }}</span>
                                                        </td>
                                                    </template>
                                                    <!-- cadRequestColorPers[ii].exterior_wall_tile.color_construction == '1' -->
                                                    <span class="overline">外壁タイル</span>
                                                </v-tooltip>

                                                <!-- 外壁仕上げ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important" :key="ii + header" v-if="header == '外壁仕上げ'">
                                                    <template v-slot:activator="{on,attrs}">
                                                        <td :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" v-bind="attrs" v-on="on" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setTileExternal(ii, editCadRequestColorPers[ii].external_wall_finish)"
                                                                    v-model="editCadRequestColorPers[ii].external_wall_finish"
                                                                    dense
                                                                    clearable
                                                                    :items="TILE_EXTERNAL"
                                                                    item-text="external_color" item-value="external_color">
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">外壁仕上げ</span>
                                                </v-tooltip>

                                                <!--td バルコニーガラス -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'バルコニーガラス'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                            <!-- {{ editCadRequestColorPersContent }} -->
                                                                <v-combobox 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setBalconyGlass(ii, editCadRequestColorPers[ii].balcony_glass)" 
                                                                    v-model="editCadRequestColorPers[ii].balcony_glass" 
                                                                    dense 
                                                                    clearable
                                                                    :items="balconyGlass" 
                                                                    item-text="text" item-value="value"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">バルコニーガラス</span>
                                                </v-tooltip>
                                                
                                                <!--td デザインルーバー -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'デザインルーバー'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleDialogDesignLouvers(ii)"
                                                                v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            {{ editCadRequestColorPers[ii].design_louver }}
                                                        </td>
                                                    </template>
                                                    <span class="overline">デザインルーバー</span>
                                                </v-tooltip>

                                                <!--td サッシ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'サッシ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersSash(ii,editCadRequestColorPers[ii].sash)" 
                                                                    v-model="editCadRequestColorPers[ii].sash" 
                                                                    dense 
                                                                    clearable
                                                                    :items="SASH_SELECTION" 
                                                                    item-text="sashSelectionName" item-value="sashSelectionCode"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">サッシ</span>
                                                </v-tooltip>

                                                <!--td 玄関ドア -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '玄関ドア'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td 
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : toggleDialogEntranceDoor(ii)" 
                                                            v-bind="attrs"  v-on="on" 
                                                            :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <span class="required">{{editCadRequestColorPers[ii].front_door.door_item ? editCadRequestColorPers[ii].front_door.door_item + ' / ' + editCadRequestColorPers[ii].front_door.door_color : editCadRequestColorPers[ii].front_door.door_color}}</span>
                                                        </td>
                                                    </template>
                                                    <span class="overline">玄関ドア</span>
                                                </v-tooltip>

                                                <!-- 木目調軒天 -->

                                                <!--td モール・矢切飾り --> 
                                                <!-- :items="mallAndArrowheadDecorationList" -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'モール・矢切飾り'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :items="MOLDING_SELECTION"
                                                                    item-value="moldingSelectionCode"
                                                                    item-text="moldingSelectionName"
                                                                    v-model="editCadRequestColorPers[ii].mall_and_arrowhead_decoration"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                                    dense
                                                                    clearable> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">モール・矢切飾り</span>
                                                </v-tooltip>

                                                <!--td バルコニー帯 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'バルコニー帯'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="editCadRequestColorPers[ii].balcony_belt"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                                    dense
                                                                    clearable> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">バルコニー帯</span>
                                                </v-tooltip>

                                                <!--td タイル面帯 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'タイル面帯'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="editCadRequestColorPers[ii].tile_band"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                                    dense
                                                                    clearable> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">タイル面帯</span>
                                                </v-tooltip>

                                                <!--td 化粧帯(1F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '化粧帯(1F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="editCadRequestColorPers[ii].decorative_belt_1f"
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                                    dense
                                                                    clearable>
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">化粧帯(1F)</span>
                                                </v-tooltip>

                                                <!--td 化粧帯(2F) -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '化粧帯(2F)'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox
                                                                    :items="BALCONY_BELT_MAKEUP_TILES"
                                                                    item-value="balcony_belt_value"
                                                                    item-text="balcony_belt_name"
                                                                    v-model="editCadRequestColorPers[ii].decorative_belt_2f" 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''"
                                                                    dense
                                                                    clearable>
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">化粧帯(2F)</span>
                                                </v-tooltip>

                                                <!--td 軒天 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '軒天'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox           
                                                                    v-model="editCadRequestColorPers[ii].eaves_of_a_house" 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersEaves(ii, editCadRequestColorPers[ii].eaves_of_a_house)" 
                                                                    dense
                                                                    clearable 
                                                                    :items="EAVES_SELECTIONS" 
                                                                    item-text="eaves_name" 
                                                                    item-value="eaves_value"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">軒天</span>
                                                </v-tooltip>

                                                <!-- 軒樋 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '軒樋'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox           
                                                                    v-model="editCadRequestColorPers[ii].eaves_gutter" 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersEavesGutter(ii, editCadRequestColorPers[ii].eaves_gutter)" 
                                                                    dense
                                                                    clearable 
                                                                    :items="EAVES_GUTTER_SELECTION" 
                                                                    item-text="name" 
                                                                    item-value="code"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                        <!-- :disabled="editCadRequestRevisionContent.house_type_id != 3 && 
                                                            editCadRequestRevisionContent.house_type_id != 29" 
                                                        :style="editCadRequestRevisionContent.house_type_id != 3 && 
                                                            editCadRequestRevisionContent.house_type_id != 29 ? 'background-color: #34495e;' : ''"  -->
                                                    </template>
                                                    <span class="overline">軒樋</span>
                                                </v-tooltip>


                                                <!--td 破風 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '破風'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersBreaking_wind(ii, editCadRequestColorPers[ii].breaking_wind)" 
                                                                    v-model="editCadRequestColorPers[ii].breaking_wind" 
                                                                    dense
                                                                    clearable 
                                                                    :items="GABLE_SELECTIONS" 
                                                                    item-text="gable_name" item-value="gable_value"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">破風</span>
                                                </v-tooltip>

                                                <!--td 土台水切り -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '土台水切り'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersBase_draining(ii, editCadRequestColorPers[ii].base_draining)" 
                                                                    v-model="editCadRequestColorPers[ii].base_draining" 
                                                                    dense 
                                                                    clearable
                                                                    :items="BASE_DRAINERS" 
                                                                    item-text="base_drainer_name" item-value="base_drainer_value"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">土台水切り</span>
                                                </v-tooltip>

                                                <!--td ポーチタイル -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'ポーチタイル'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  
                                                            :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                            :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                            @click="!COLOR_PERS_RESTRICTION.includes(header) ? '' : togglePorchTilesDialog(ii)"  
                                                            v-bind="attrs"  
                                                            v-on="on" 
                                                            :class="`pattern-${requestPattern}-${pattern}`"  
                                                            style="cursor: pointer">
                                                            {{ editCadRequestColorPers[ii].porch_tile.porch_tile_item_color}}
                                                        </td>
                                                    </template>
                                                    <span class="overline">ポーチタイル</span>
                                                </v-tooltip>

                                                <!--td 視点方向 -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '視点方向'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersPerspective_direction(ii, editCadRequestColorPers[ii].perspective_direction)" 
                                                                    v-model="editCadRequestColorPers[ii].perspective_direction" 
                                                                    dense 
                                                                    clearable
                                                                    :items="VIEW_DIRECTION_SELECTIONS" 
                                                                    item-text="direction" item-value="direction"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点方向</span>
                                                </v-tooltip>

                                                <!--td 視点高さ -->
                                                <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == '視点高さ'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer" :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''">
                                                            <v-container>
                                                                <v-combobox 
                                                                    :disabled="!COLOR_PERS_RESTRICTION.includes(header)" 
                                                                    :style="!COLOR_PERS_RESTRICTION.includes(header) ? 'background-color: #34495e;' : ''" 
                                                                    @change="!COLOR_PERS_RESTRICTION.includes(header) ? '' : setColorPersViewpoint_height(ii, editCadRequestColorPers[ii].viewpoint_height)" 
                                                                    v-model="editCadRequestColorPers[ii].viewpoint_height" 
                                                                    dense 
                                                                    clearable
                                                                    :items="VIEW_HEIGHT_SELECTIONS" 
                                                                    item-text="view_height_name" item-value="view_height_value"> 
                                                                </v-combobox>
                                                            </v-container>
                                                        </td>
                                                    </template>
                                                    <span class="overline">視点高さ</span>
                                                </v-tooltip>

                                                <!--td ガーデン番号 -->
                                                <!-- <v-tooltip top color="#D3D3D3" style="opacity: 1 !important"  :key="ii + header"  v-if="header == 'ガーデン番号'" >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <td  v-bind="attrs"  v-on="on" :class="`pattern-${requestPattern}-${pattern}`"  style="cursor: pointer">
                                                            <v-container> -->
                                                                <!-- <v-autocomplete  dense> </v-autocomplete> -->
                                                                <!-- <v-select :items="options" item-value="title" v-model="gardenSelection" label="Title" class="mb-n2 ma-1" @change="StoreGarden(ii)"> -->
                                                                    <!-- <template slot="option" slot-scope="option">
                                                                        <img :src="option.cardImage" />
                                                                        {{ option.title }}
                                                                    </template> -->
                                                                    <!-- <template v-slot:selection="{item}">
                                                                        <img :src="item.cardImage" style="width:85px;" class="mr-2" />{{ item.title }}
                                                                    </template>
                                                                    <template v-slot:item="{item}">
                                                                        <img :src="item.cardImage" style="width:200px;" class="mr-2" />{{ item.title }}
                                                                    </template> -->
                                                                <!-- </v-select>
                                                            </v-container> -->
                                                        <!-- </td>
                                                    </template>
                                                    <span class="overline">ガーデン番号</span>
                                                </v-tooltip> -->
                                            </template>
                                        </template>
                                    </tr>
                                </tbody>
                            </v-simple-table><br>
                            <div>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn color="red" @click="closeColorPers(false)" dark dense>キャンセル</v-btn> -->
                                    <v-btn color="red" @click="closeColorPers(false)" dark dense>戻る</v-btn>
                                    <v-btn color="success" @click="storeColorPers()" dark dense>保存</v-btn>
                                </v-card-actions>
                            </div>
                        </v-container>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                <v-spacer/>
                    <!-- <v-btn color="red" @click="closetoggleDialogElectricalDrawing()">キャンセル</v-btn> -->
                </v-card-actions>
            </v-card>   
        </v-dialog>

        <!-- COPY PREVIOUS PATTERN -->
        <v-dialog v-model="previousColor" persistent width="28%">
            <v-card>
                <v-card-title> <v-spacer/><v-icon @click="previousColor = false" large color="red">mdi-close</v-icon></v-card-title>
                <v-card-text>
                    <v-row no-gutters>
                        <v-col width="50%">
                            <center>
                                <v-simple-table style="width: 250px !important;" class="ml-2">
                                    <thead>
                                        <tr>
                                            <th style="font-size: 15px !important;">SELECT REVISION PLAN</th>
                                            <!-- <th style="font-size: 15px !important;">SELECT PATTERN</th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in existingColorPers" :key="index">
                                            <td style="border: none !important">      
                                                <span style="font-size: 15px !important;">{{item.temp_created}}</span>
                                                <v-btn style="margin-left: 25px !important; margin-right: 25px !important;" @click="copyToLatest(item)" dense color="primary"
                                                :disabled="disableCopyPrevious(item)"
                                                >{{item.revision}} </v-btn>
                                                <span style="font-size: 15px !important;">No. {{index+1}}</span>
                                            </td>
                                            <!-- <td>
                                                <span style="font-size: 15px !important;">パ一タン</span>
                                                <v-btn style="margin-left: 25px !important; margin-right: 25px !important;" dense color="primary">{{index}}</v-btn>
                                            </td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </center>
                        </v-col>
                        <v-col class="pr-0 mr-0" width="50%">
                            <v-simple-table style="width: 230px !important;">
                                <thead>
                                    <tr>
                                        <!-- <th style="font-size: 15px !important;">SELECT REVISION PLAN</th> -->
                                        <th style="font-size: 15px !important;">SELECT PATTERN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in requestPattern" :key="index">
                                        <!-- <td >      
                                            <span style="font-size: 15px !important;">{{item.temp_created}}</span>
                                            <v-btn style="margin-left: 25px !important; margin-right: 25px !important;" @click="copyToLatest(item)" dense color="primary">{{item.revision}}</v-btn>
                                            <span style="font-size: 15px !important;">No. {{index+1}}</span>
                                        </td> -->
                                        <td v-if="item != newIndex+1" style="border: none !important">
                                            <span style="font-size: 15px !important;">パ一タン</span>
                                            <v-btn style="margin-left: 25px !important;" @click="setPattern(item-1)" dense color="primary">{{item}}</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>


                </v-card-text><br>
                <!-- <v-card-actions><v-spacer/>
                    <v-btn @click="acceptNoRequestColors()" color="success" dark depressed width="80px">Yes</v-btn>
                    <v-btn @click="closeNoRequestColors()" depressed color="#E74C3C" class="white--text" width="80px">戻る</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
        <!-- ****** -->

        <v-dialog v-model="noRequestColor" persistent width="26%">
            <v-card>
                <v-card-title>
                    <span class="overline">カラーパース依頼内容</span>
                </v-card-title><v-spacer/>
                <v-card-text>
                    <div class="ml-4 mt-3 overline" style="font-size:18px !important;">
                        依頼はなしで良いでしょうか。
                    </div>
                </v-card-text>
                <v-card-actions><v-spacer/>
                    <v-btn @click="acceptNoRequestColors()" color="success" dark depressed width="80px">Yes</v-btn>
                    <v-btn @click="closeNoRequestColors()" depressed color="#E74C3C" class="white--text" width="80px">戻る</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <v-dialog  v-model="dialogRoof" persistent max-width="300">
            <v-form id="StoreRoof" ref="StoreRoof" @submit.prevent="StoreRoof">
                <v-card>
                    <v-card-title> 
                        <span class="overline">屋根</span> 
                        <v-spacer></v-spacer>
                        <v-icon @click="dialogRoof = false" dark>mdi-close</v-icon>
                    </v-card-title>
                        <v-container>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete 
                                            v-model="selectedRoof"
                                            outlined dense 
                                            label="屋根材" :items="filteredRoof" 
                                            item-text="material" item-value="id"
                                            :rules="rules.required" class="required"
                                            >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" outlined dense label="屋根の色">
                                        <v-autocomplete 
                                            v-model="roofColor"
                                            outlined dense 
                                            label="屋根の色" :items="roofSelectionsCombi" 
                                            item-text="color" 
                                            item-value="color"
                                            :rules="rules.required" class="required"
                                            >
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="success" type="submit" >保存</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog  v-model="dialogSiding1F" persistent max-width="400">
            <form id="StoreSiding1f" ref="StoreSiding1f" @submit.prevent="StoreSiding1f">
                <v-card>
                    <v-card-title> 
                        <span class="overline">吹付け (1F) </span>
                        <v-spacer></v-spacer>
                        <v-icon @click="dialogSiding1F = false" dark>mdi-close</v-icon>
                    </v-card-title>
                    <v-container>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group
                                    v-model="siding1F"
                                    dense
                                    >
                            <template v-for="(item,i) in SPRAY_ITEMS">
                                <v-radio v-if="item.spray_name == 'なし'"
                                    :key="i"
                                    :label="item.spray_name"
                                    value="0">
                                </v-radio>
                                <!-- :value="item.spray_name == 'なし'  ? '0' : item.spray_name == 'レナラックⅠ吹付' ? 'LENA_RACK' :item.spray_name == 'シポストーン厚吹' ? 'SPRAY_SHIPO' : item.spray_name == 'シナジオ・ｉ (超高耐久・低汚染)' ? 'SPRAY_SYNAGIO' : item.spray_name == '櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）' ? 'SIPOROKS' : item.spray_name == '櫛引柄デザインサイディング' ? 'COMB_DESIGNS' : null" -->
                                <v-radio v-else
                                    :key="i"
                                    :label="item.spray_name"
                                    :value=" item.spray_name == 'レナラックⅠ吹付' ? 'LENA_RACK' :item.spray_name == 'シポストーン厚吹' ? 'SPRAY_SHIPO' : item.spray_name == 'シナジオ・ｉ (超高耐久・低汚染)' ? 'SPRAY_SYNAGIO' : item.spray_name == '櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）' ? 'SIPOROKS' : item.spray_name == '櫛引柄デザインサイディング' ? 'COMB_DESIGNS' : null"
                                    @click="toggleDialogExteriorRequestContent('siding1F')">
                                </v-radio>
                            </template>
                                        
                                        <!-- <v-radio
                                            label="なし"
                                            value="0"
                                        ></v-radio> -->
                                            <!-- @click="toggleDialogExteriorRequestContent('siding1F')" -->
                                        <!-- <v-radio
                                            label="レナラックⅠ吹付"
                                            value="LENA_RACK"
                                            @click="toggleDialogExteriorRequestContent('siding1F')"
                                        ></v-radio>
                                        <v-radio
                                            label="シポストーン厚吹"
                                            value="SPRAY_SHIPO"
                                            @click="toggleDialogExteriorRequestContent('siding1F')"
                                        ></v-radio>
                                        <v-radio
                                            label="シナジオ・ｉ (超高耐久・低汚染)"
                                            value="SPRAY_SYNAGIO"
                                            @click="toggleDialogExteriorRequestContent('siding1F')"
                                        ></v-radio>
                                        <v-radio
                                            label="櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）"
                                            value="SIPOROKS"
                                            @click="toggleDialogExteriorRequestContent('siding1F')"
                                        ></v-radio>
                                        <v-radio
                                            label="櫛引柄デザインサイディング"
                                            value="COMB_DESIGNS"
                                            @click="toggleDialogExteriorRequestContent('siding1F')"
                                        ></v-radio> -->
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn dark color="red" @click="dialogSiding1F = false">キャンセル</v-btn>
                            <v-btn dark color="success" @click="StoreSiding1f()">保存</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-dialog>

        <v-dialog  v-model="dialogSiding2F" persistent max-width="400">
            <v-card>
                <v-card-title> <span class="overline">吹付け (2F) </span> </v-card-title>
                    <v-container>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group
                                    v-model="siding2F"
                                    dense
                                    >
                            <template v-for="(item,i) in SPRAY_ITEMS">
                                <v-radio v-if="item.spray_name == 'なし'"
                                    :key="i"
                                    :label="item.spray_name"
                                    value="0">
                                </v-radio>
                                <!-- :value="item.spray_name == 'なし'  ? '0' : item.spray_name == 'レナラックⅠ吹付' ? 'LENA_RACK' :item.spray_name == 'シポストーン厚吹' ? 'SPRAY_SHIPO' : item.spray_name == 'シナジオ・ｉ (超高耐久・低汚染)' ? 'SPRAY_SYNAGIO' : item.spray_name == '櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）' ? 'SIPOROKS' : item.spray_name == '櫛引柄デザインサイディング' ? 'COMB_DESIGNS' : null" -->
                                <v-radio v-else
                                    :key="i"
                                    :label="item.spray_name"
                                    :value=" item.spray_name == 'レナラックⅠ吹付' ? 'LENA_RACK' :item.spray_name == 'シポストーン厚吹' ? 'SPRAY_SHIPO' : item.spray_name == 'シナジオ・ｉ (超高耐久・低汚染)' ? 'SPRAY_SYNAGIO' : item.spray_name == '櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）' ? 'SIPOROKS' : item.spray_name == '櫛引柄デザインサイディング' ? 'COMB_DESIGNS' : null"
                                    @click="toggleDialogExteriorRequestContent('siding2F')">
                                </v-radio>
                            </template>
                                        <!-- <v-radio
                                            label="なし"
                                            value="0"
                                        ></v-radio> -->
                                            <!-- @click="toggleDialogExteriorRequestContent('siding2F')" -->
                                        <!-- <v-radio
                                            label="レナラックⅠ吹付"
                                            value="LENA_RACK"
                                            @click="toggleDialogExteriorRequestContent('siding2F')"
                                        ></v-radio>
                                        <v-radio
                                            label="シポストーン厚吹"
                                            value="SPRAY_SHIPO"
                                            @click="toggleDialogExteriorRequestContent('siding2F')"
                                        ></v-radio>
                                        <v-radio
                                            label="シナジオ・ｉ (超高耐久・低汚染)"
                                            value="SPRAY_SYNAGIO"
                                            @click="toggleDialogExteriorRequestContent('siding2F')"
                                        ></v-radio>
                                        <v-radio
                                            label="櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）"
                                            value="SIPOROKS"
                                            @click="toggleDialogExteriorRequestContent('siding2F')"
                                        ></v-radio>
                                        <v-radio
                                            label="櫛引柄デザインサイディング"
                                            value="COMB_DESIGNS"
                                            @click="toggleDialogExteriorRequestContent('siding2F')"
                                        ></v-radio> -->
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" @click="dialogSiding2F = false">キャンセル</v-btn>
                    <v-btn dark color="success" @click="StoreSiding2f()">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog  v-model="dialogSiding3F" persistent max-width="400">
            <v-card>
                <v-card-title> <span class="overline">吹付け (3F) </span> </v-card-title>
                    <v-container>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group
                                    v-model="siding3F"
                                    dense
                                    >
                            <template v-for="(item,i) in SPRAY_ITEMS">
                                <v-radio v-if="item.spray_name == 'なし'"
                                    :key="i"
                                    :label="item.spray_name"
                                    value="0">
                                </v-radio>
                                <!-- :value="item.spray_name == 'なし'  ? '0' : item.spray_name == 'レナラックⅠ吹付' ? 'LENA_RACK' :item.spray_name == 'シポストーン厚吹' ? 'SPRAY_SHIPO' : item.spray_name == 'シナジオ・ｉ (超高耐久・低汚染)' ? 'SPRAY_SYNAGIO' : item.spray_name == '櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）' ? 'SIPOROKS' : item.spray_name == '櫛引柄デザインサイディング' ? 'COMB_DESIGNS' : null" -->
                                <v-radio v-else
                                    :key="i"
                                    :label="item.spray_name"
                                    :value=" item.spray_name == 'レナラックⅠ吹付' ? 'LENA_RACK' :item.spray_name == 'シポストーン厚吹' ? 'SPRAY_SHIPO' : item.spray_name == 'シナジオ・ｉ (超高耐久・低汚染)' ? 'SPRAY_SYNAGIO' : item.spray_name == '櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）' ? 'SIPOROKS' : item.spray_name == '櫛引柄デザインサイディング' ? 'COMB_DESIGNS' : null"
                                    @click="toggleDialogExteriorRequestContent('siding3F')">
                                </v-radio>
                            </template>
                                        <!-- <v-radio
                                            label="なし"
                                            value="0"
                                        ></v-radio> -->
                                            <!-- @click="toggleDialogExteriorRequestContent('siding3F')" -->
                                        <!-- <v-radio
                                            label="レナラックⅠ吹付"
                                            value="LENA_RACK"
                                            @click="toggleDialogExteriorRequestContent('siding3F')"
                                        ></v-radio>
                                        <v-radio
                                            label="シポストーン厚吹"
                                            value="SPRAY_SHIPO"
                                            @click="toggleDialogExteriorRequestContent('siding3F')"
                                        ></v-radio>
                                        <v-radio
                                            label="シナジオ・ｉ (超高耐久・低汚染)"
                                            value="SPRAY_SYNAGIO"
                                            @click="toggleDialogExteriorRequestContent('siding3F')"
                                        ></v-radio>
                                        <v-radio
                                            label="櫛引き調横貼防火サイディング＋シポロックリシンNEO厚吹（防カビ・防藻）"
                                            value="SIPOROKS"
                                            @click="toggleDialogExteriorRequestContent('siding3F')"
                                        ></v-radio>
                                        <v-radio
                                            label="櫛引柄デザインサイディング"
                                            value="COMB_DESIGNS"
                                            @click="toggleDialogExteriorRequestContent('siding3F')"
                                        ></v-radio> -->
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" @click="dialogSiding3F = false">キャンセル</v-btn>
                    <v-btn dark color="success" @click="StoreSiding3f()">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogExteriorRequestContent" persistent max-width="300">
            <v-card>
                <v-card-title> 
                    <span class="overline">外壁色依頼内容</span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="dialogExteriorRequestContent = false">mdi-close</v-icon>
                </v-card-title>
                <v-container>
                    <v-card-text>
                        <!-- LENA_RACK  -->
                        <template v-if="activeSidingDropdown == 'LENA_RACK'">
                            <v-autocomplete v-model="sidingSelection" outlined dense :items="LENA_RACK" item-text="lena_name" item-value="lena_name"></v-autocomplete>
                            <!-- <v-autocomplete v-model="sidingSelection" outlined dense :items="LENA_RACK" item-text="lena_name" item-value="id"></v-autocomplete> -->
                        </template>

                        <!-- SPRAY_SHIPO  -->
                        <template v-if="activeSidingDropdown == 'SPRAY_SHIPO'">
                            <v-autocomplete v-model="sidingSelection" outlined dense :items="SPRAY_SHIPO" item-text="shipo_name" item-value="shipo_name"></v-autocomplete>
                            <!-- <v-autocomplete v-model="sidingSelection" outlined dense :items="SPRAY_SHIPO" item-text="shipo_name" item-value="id"></v-autocomplete> -->
                        </template>

                        <!-- SPRAY_SYNAGIO  -->
                        <template v-if="activeSidingDropdown == 'SPRAY_SYNAGIO'">
                            <v-autocomplete v-model="sidingSelection" outlined dense :items="SPRAY_SYNAGIO" item-text="synagio_name" item-value="synagio_name"></v-autocomplete>
                            <!-- <v-autocomplete v-model="sidingSelection" outlined dense :items="SPRAY_SYNAGIO" item-text="synagio_name" item-value="id"></v-autocomplete> -->
                        </template>

                        <!-- SIPOROKS  -->
                        <template v-if="activeSidingDropdown == 'SIPOROKS'">
                            <v-autocomplete v-model="sidingSelection" outlined dense :items="SIPOROKS" item-text="siporok_name" item-value="siporok_name"></v-autocomplete>
                            <!-- <v-autocomplete v-model="sidingSelection" outlined dense :items="SIPOROKS" item-text="siporok_name" item-value="id"></v-autocomplete> -->
                        </template>

                        <!-- COMB_DESIGNS  -->
                        <template v-if="activeSidingDropdown == 'COMB_DESIGNS'">
                            <v-autocomplete v-model="sidingSelection" outlined dense :items="COMB_DESIGNS" item-text="comb_name" item-value="comb_name"></v-autocomplete>
                            <!-- <v-autocomplete v-model="sidingSelection" outlined dense :items="COMB_DESIGNS" item-text="comb_name" item-value="id"></v-autocomplete> -->
                        </template>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" @click="dialogExteriorRequestContent = false">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogExteriorWallTiles" persistent max-width="300">
            <v-card>
                <v-card-title> 
                    <span class="overline">外壁タイル</span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="dialogExteriorWallTiles = false">mdi-close</v-icon>
                </v-card-title>
                <v-container>
                    <v-card-text>
                        <v-autocomplete outlined dense label="色施工" 
                            v-model="exteriorObj.toneSelection"
                            :items="colorTones" 
                            item-text="text" 
                            item-value="value"
                            @change="colorTonesSelection()">
                        </v-autocomplete>
                        <v-autocomplete outlined dense label="メインの外壁タイルの色" 
                            v-model="exteriorObj.toneColor"
                            :items="toneColorSelection" 
                            item-text="color" 
                            item-value="color">
                        </v-autocomplete>
                        <v-autocomplete v-if="exteriorObj.toneSelection == '2'" outlined dense label="アクセント外壁タイルの色" 
                            v-model="exteriorObj.toneColorAccent"
                            :items="toneColorSelection" 
                            item-text="color" 
                            item-value="color">
                        </v-autocomplete>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" @click="StoreExteriorWallTiles(exteriorObj)">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialogDesignLouver" persistent max-width="300">
            <v-card>
                <v-card-title> 
                    <span class="overline">デザインルーバー</span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="dialogDesignLouver = false">mdi-close</v-icon>
                </v-card-title>
                <v-container>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-radio-group v-model="selectedDesignLouver" dense >
                                    <v-radio
                                        label="なし"
                                        value="1"
                                    ></v-radio>
                                    <v-radio
                                        label="木目調シート仕上げ"
                                        value="2"
                                    ></v-radio>
                                    <v-radio
                                        label="塗装仕上げ"
                                        value="3"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                                <v-expand-transition>
                                    <v-autocomplete 
                                        v-show="selectedDesignLouver == '2'" 
                                        v-model="design_louver_item"
                                        outlined 
                                        dense
                                        :items="LOUVER_WOODS"
                                        item-value="wood_name"
                                        item-text="wood_name"
                                    ></v-autocomplete>
                                </v-expand-transition>
                                
                                <v-expand-transition>
                                    <v-autocomplete 
                                        v-show="selectedDesignLouver == '3'" 
                                        v-model="design_louver_item"
                                        outlined 
                                        dense
                                        :items="LOUVER_PAINTS"
                                        item-value="paint_name"
                                        item-text="paint_name"
                                    ></v-autocomplete>
                                </v-expand-transition>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" @click="storeDesignLouver()">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEntranceDoor" persistent max-width="300">
            <v-card>
                <v-card-title> 
                    <span class="overline">玄関ドア</span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="dialogEntranceDoor = false">mdi-close</v-icon>
                </v-card-title>
                <v-container>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-radio-group v-model="selectedEntranceDoor" @change="allEntranceDoorItem()" dense >
                                    <v-radio
                                        label="プロノーバ"
                                        value="1"
                                    ></v-radio>
                                    <v-radio
                                        label="ファノーバ"
                                        value="2"
                                    ></v-radio>
                                    <v-radio
                                        label="耐水害住宅"
                                        value="3"
                                    ></v-radio>
                                    <v-radio
                                        label="ダンジュ"
                                        value="4"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete 
                                    v-model="doorItem"
                                    outlined 
                                    dense 
                                    label="Door Item" 
                                    :items="entranceDoorItem"
                                    item-value="door_item"
                                    item-text="door_item"
                                    > 
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete 
                                    :disabled="!doorItem"
                                    v-model="doorColor"
                                    outlined 
                                    dense 
                                    label="Door Color" 
                                    :items="entranceDoorItem"
                                    item-value="door_color_abbreviation_name"
                                    item-text="door_color"
                                    > 
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" @click="storeEntranceDoor()">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPorchTiles" persistent max-width="300">
            <v-card>
                <v-card-title> 
                    <span class="overline">ポーチタイル</span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="dialogPorchTiles = false">mdi-close</v-icon>
                </v-card-title>
                <v-container>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete @change="selectPorchColor()" v-model="selectedPorchTile" :items="filterPorchTile" item-text="name" item-value="id" outlined dense ></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete v-model="porch_color" :items="porchColor" item-text="color" item-value="color" outlined dense ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="success" @click="storePorch()">保存</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment'
export default {
    // props : {
    //     dialog : Boolean,
    // },
    props:["colorPers","dialog"],
    
    data(){
        return {
            previousColor: false,
            existingColorPers: [],
            noRequestColor : false,
            gardenSelection : null,
            toneColor: null,
            toneColorAccent: null,
            options: [
                { title: "O-01", cardImage: "./img/O-01_open.png"},
                { title: "O-02", cardImage: "./img/O-02_open.png"},
                { title: "S-01", cardImage: "./img/S-01_semi-open.png"},
                { title: "S-02", cardImage: "./img/S-02_semi-open.png"},
                { title: "S-03", cardImage: "./img/S-03_semi-open.png"},
                { title: "S-04", cardImage: "./img/S-04_semi-open.png"},
                { title: "C-01", cardImage: "./img/C-01_close.png"},
                { title: "C-02", cardImage: "./img/C-02_close.png"},
            ],
            entranceDoorItem: [],
            filterDoor: [],
            filteredTiles: [],
            filterPorchTile: [],
            cadRequestColorPersContent: {
                is_request_color_info: null,
                roof: {
                    roofing_material: null,
                    roof_color: null,
                    },
                spray_1f: {
                    exteriorRequestContent: null,
                    },
                spray_2f: {
                    exteriorRequestContent: null,
                    },
                spray_3f: {
                    exteriorRequestContent: null,
                    },
                exterior_wall_tile : {
                    color_construction: null,
                    exterior_wall_tile: null,
                    accent_wall_color: null
                    },
                external_wall_finish : null,
                balcony_glass : null,
                design_louver : null,
                sash : null,
                front_door : {
                    entrance_door_type: null,
                    door_item: null,
                    door_color: null,
                    },
                mall_and_arrowhead_decoration : null,
                balcony_belt : null,
                tile_band : null,
                decorative_belt_1f : null,
                decorative_belt_2f : null,
                eaves_of_a_house : null,
                eaves_gutter : null,
                breaking_wind : null,
                base_draining : null,
                porch_tile : {
                    porch_tile_item: null,
                    porch_tile_item_color: null,
                },
                perspective_direction : null,
                viewpoint_height : null,
                garden_number : null,
            },
            // radio: null,
            requestContents: [
                {text: "仕様書に従って作成", desc: "※仕様書指示がない場合はおまかせで作成", value:1},
                {text: "色情報を指示して依頼", desc: "※着⼿図⾯依頼以降は選択不可", value:2},
                {text: "依頼なし", desc: "", value:null},
            ],
            viewDirectionSelections: [
                "1",
                "1-2",
                "2",
                "2-3",
                "3",
                "3-4",
                "4",
                "4-5",
                "5",
                "5-6",
                "6",
                "6-7",
                "7",
                "7-8",
                "8",
                "8-9",
                "9",
                "9-10",
                "10",
                "10-11",
                "11",
                "11-12",
                "12",
                "12-1",
            ],
            viewHeightSelections: [
                "LU",
                "1600",
                "1800",
                "2000",
                "2500",
                "3000",
                "3500",
                "4000",
                "4500",
                "5000",
                "5500",
                "6000",
                "6500",
                "7000",
                "7500",
                "8000",
                "8500", 
                "9000", 
                "9500", 
                "10000",
                "10500", 
                "11000",
                "11500",
                "12000",
            ],
            
            e6: 1,
            requestPattern: 0,
            patterns : {
                1: { direction: null, height: null },
                2: { direction: null, height: null },
                3: { direction: null, height: null },
                4: { direction: null, height: null },
            },

            mallAndArrowheadDecorationList : [
                "",
                { text: "FC-1(ｸﾞﾘｰﾝ)", value: "FC-1(ｸﾞﾘｰﾝ)" },
                { text: "FC-3(ﾌﾞﾗｳﾝ)", value: "FC-3(ﾌﾞﾗｳﾝ)" },
                { text: "FC-5(ｱｲﾎﾞﾘｰ)", value: "FC-5(ｱｲﾎﾞﾘｰ)" },
                { text: "FC-4(ﾎﾜｲﾄ)", value: "FC-4(ﾎﾜｲﾄ)" },
            ],
            balconyBeltMakeupTileFaceSelection: [
                "",
                { text: "", value: "" }, // none
                { text: "外壁同色", value: "外壁同色" }, //  Same color as the outer wall
                { text: "FC-1(ｸﾞﾘｰﾝ)", value: "FC-1(ｸﾞﾘｰﾝ)" }, // FC-1 (green)
                { text: "FC-3(ﾌﾞﾗｳﾝ)", value: "FC-3(ﾌﾞﾗｳﾝ)" }, // FC-3 (Brown)
                { text: "FC-5(ｱｲﾎﾞﾘｰ)", value: "FC-5(ｱｲﾎﾞﾘｰ)" }, // FC-5 (ivory)
                { text: "FC-4(ﾎﾜｲﾄ)", value: "FC-4(ﾎﾜｲﾄ)" }, // FC-4 (white)
            ],

            colorPersRequestHeaders: [
                '依頼日',
                '図面番号',
                '建物タイプ',
                '屋根',
                '吹付け(1F)',
                '吹付け(2F)',
                '吹付け(3F)',
                '外壁タイル',
                '外壁仕上げ',
                'バルコニーガラス',
                'デザインルーバー',
                'サッシ',
                '玄関ドア',
                // '木目調軒天',
                'モール・矢切飾り',
                'バルコニー帯',
                'タイル面帯',
                '化粧帯(1F)',
                '化粧帯(2F)',
                '軒天',
                '軒樋',
                '破風',
                '土台水切り',
                'ポーチタイル',
                '視点方向',
                '視点高さ',
                // 'ガーデン番号',
            ],
            exteriorObj: {
                toneSelection : null,
                toneColor : null,
                toneColorAccent : null,
            },
            dialogColorPers: false,
            tempHouseType: 1,
            dialogRoof: false,
            selectedRoof: null,
            roofColor:null,

            dialogSiding1F: false,
            siding1F: undefined,
            dialogSiding2F: false,
            siding2F: undefined,
            dialogSiding3F: false,
            siding3F: undefined,

            dialogExteriorRequestContent: false,
            dialogExteriorWallTiles: false,
            dialogDesignLouver: false,
            dialogEntranceDoor: false,
            selectedDesignLouver: undefined,
            activeSidingDropdown: null,
            colorTones: [
                {text: '1色施工', value: '1'},
                {text: '2色施工', value: '2'}
            ],
            balconyGlass: [
                { text: "透明ｶﾞﾗｽ (ｱｰﾊﾞﾝｸﾞﾚｰ)", value: "透明ｶﾞﾗｽ" },
                { text: "ﾐｽﾄｶﾞﾗｽ (ｱｰﾊﾞﾝｸﾞﾚｰ)", value: "ﾐｽﾄｶﾞﾗｽ" },
            ],
            
            sash : [
                { text: "ｱｰﾊﾞﾝｸﾞﾚｰ (UG)", value: "UG" },
                { text: "ﾎﾜｲﾄ (WH)", value: "WH" },
                { text: "ﾌﾞﾗｯｸ (BK)", value: "BK" },
                { text: "木目調 (LE)", value: "LE" },
            ],
            selectedEntranceDoor: undefined,
            dialogPorchTiles: false,
            selectedPorchTile: null,
            colorPersIndex: null,
            sidingSelection : null,
            balconyGlassSelection : null,
            design_louver_item : null,
            curr_index : null,
            doorItem : null,
            doorColor : null,
            eaves : null,
            porch_color: null,
            // porch_house: null,
            // porcHouseType: [],
            porchColor: [],

            toneColorSelection: [],
            // toneSelection: null,
            teTiles : {},
            newIndex: 0,

        }
    },

    computed: {
        ...mapState(
            [ 
                'ROOF_SELECTION', 
                'rules',
                'LENA_RACK',
                'SPRAY_SHIPO',
                'SPRAY_SYNAGIO',
                'COMB_DESIGNS',
                'SIPOROKS',
                'LOUVER_ITEMS',
                'LOUVER_WOODS',
                'LOUVER_PAINTS',
                'ENTRANCE_DOORS',
                'EAVES_SELECTIONS',
                'EAVES_GUTTER_SELECTION',
                'GABLE_SELECTIONS',
                'BASE_DRAINERS',
                'PORCH_TILES',
                'VIEW_DIRECTION_SELECTIONS',
                'VIEW_HEIGHT_SELECTIONS',
                'HOUSE_TYPES',
                'TILES',
                'BALCONY_BELT_MAKEUP_TILES',
                'MOLDING_SELECTION',
                'SASH_SELECTION',
                'SPRAY_ITEMS',
                'COLOR_PERS_RESTRICTION',
                'TILE_EXTERNAL',
                'COLOR_PERS_OBJ_NAME',
                'cadRequestLatestRevision',
                'cadRequestBasicInformation',
                'cadRequestRevisionContent',
                'cadRequestColorPers',
                'hideColorPersTable',
                'editCadRequestColorPers',
                'editCadRequestRevisionContent',
                'editMode',
                'editRevision',
                'storeRequestContents',
                'radio',
                'existingRevisions'
            ]
        ),

        filteredRoof(){
            // if(!this.tempHouseType){
            //     return this.ROOF_SELECTION.filter(res => res.house_type_id == null);
            // }

            // return this.ROOF_SELECTION.filter(res => res.house_type_id == this.tempHouseType);
            let filteredSelection;
                if (!this.cadRequestBasicInformation.house_type_id) {
                    filteredSelection = this.ROOF_SELECTION.filter(res => res.selections_house_type === null);
                } else {
                    filteredSelection = this.ROOF_SELECTION.filter(res => {
                        if (res.selections_house_type) {
                            return res.selections_house_type.some(element => element.house_type_id === this.cadRequestBasicInformation.house_type_id);
                        }
                        return false;
                    });
                }
                // console.log('Filtered Roof Selection:', filteredSelection);
                return filteredSelection;
        },

        roofSelectionsCombi(){
            if(!this.selectedRoof) return

            const data = this.filteredRoof.find(res => res.id == this.selectedRoof);
            return data.selections_combi
        },

        pronovaEntranceDoors(){
            const doors = ['PRONOVA (waku)','PRONOVA (jiku)']
            const data =  this.ENTRANCE_DOORS.filter(res => doors.includes(res.door_type))
            return data;
        },

        fanovaEntranceDoors(){
            const doors = ['FANOVA (waku)','FANOVA (jiku)']
            const data =  this.ENTRANCE_DOORS.filter(res => doors.includes(res.door_type))
            return data;
        },

        watertightEntranceDoors(){
            const doors = ['WATERTIGHT'];
            const data = this.ENTRANCE_DOORS.filter(res => doors.includes(res.door_type))
            return data;
        },

        danjouEntranceDoors(){
            const doors = ['DANNJU (waku)'];
            const data = this.ENTRANCE_DOORS.filter(res => doors.includes(res.door_type))
            return data;
        },

    },

    methods: {
        ...mapActions(
            [
                '_getRoofSelection',
                '_getLenaRack',
                '_getSprayShipo',
                '_getSpraySynagio',
                '_getCombDesigns',
                '_getSiporoks',
                '_getLouverItems',
                '_getLouverWoods',
                '_getLouverPaints',
                '_getEntranceDoors',
                '_getEavesSelections',
                '_getEavesGutterSelections',
                '_getGableSelections',
                '_getBaseDrainers',
                '_getPorchTiles',
                '_getViewDirectionSelections',
                '_getViewHeightSelections',
                '_getTiles',
                '_getBalconyBeltMakeupTiles',
                '_getMoldingSelection',
                '_getSashSelection',
                '_getSprayItems',
                '_getTileExternal',
                // '_getColorPersObjName',
            ]
        ),

        setEmptySelection(ii) {
            if (this.editMode) {
                // console.log(this.replaceNullWithDefault(this.editCadRequestColorPers[ii], this.COLOR_PERS_OBJ_NAME))
                this.$set(this.editCadRequestColorPers, ii, this.replaceNullWithDefault(this.editCadRequestColorPers[ii], this.COLOR_PERS_OBJ_NAME))
            } else {
                // console.log(this.replaceNullWithDefault(this.cadRequestColorPers[ii], this.COLOR_PERS_OBJ_NAME))
                this.$set(this.cadRequestColorPers, ii, this.replaceNullWithDefault(this.cadRequestColorPers[ii], this.COLOR_PERS_OBJ_NAME))
            }
        },

        
        replaceNullWithDefault(obj, restrictedKeys) {
            Object.keys(obj).forEach(key => {
                if (restrictedKeys.includes(key)) {
                    if (obj[key] === null) {
                        obj[key] = '仕様書に準ずる'
                    }
                } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    this.replaceNullWithDefault(obj[key], restrictedKeys)
                }
            });

            if (restrictedKeys.includes('spray_1f') && obj['spray_1f'] && obj['spray_1f']['exteriorRequestContent'] === null) {
                obj['spray_1f']['exteriorRequestContent'] = '仕様書に準ずる'
            }
            if (restrictedKeys.includes('spray_2f') && obj['spray_2f'] && obj['spray_2f']['exteriorRequestContent'] === null) {
                obj['spray_2f']['exteriorRequestContent'] = '仕様書に準ずる'
            }
            if (restrictedKeys.includes('spray_3f') && obj['spray_3f'] && obj['spray_3f']['exteriorRequestContent'] === null) {
                obj['spray_3f']['exteriorRequestContent'] = '仕様書に準ずる'
            }
            if (restrictedKeys.includes('exterior_wall_tile') && obj['exterior_wall_tile'] && obj['exterior_wall_tile']['exterior_wall_tile'] === null) {
                obj['exterior_wall_tile']['exterior_wall_tile'] = '仕様書に準ずる';
            }
            // if (restrictedKeys.includes('door_color') && obj['front_door'] && obj['front_door']['door_color'] === null) {
            //     obj['front_door']['door_color'] = '仕様書に準ずる';
            // }
            this.$forceUpdate()

            return obj
        },
        openPreviousSelection(ii){
            // console.log(ii,'iiii')
            this.previousColor = true;
            this.newIndex = ii
            
            // console.log(this.newIndex + 1, this.requestPattern)
        },

        disableCopyPrevious(item) {
            if(this.editMode) {
                return this.editCadRequestRevisionContent.house_type_id !== item.house_type_id
            } else {
                return this.cadRequestBasicInformation.house_type_id !== item.house_type_id
            }
        },

        setPattern(item){
            let color = {
                is_request_color_info: this.cadRequestColorPers[item].is_request_color_info,
                roof: {
                        roofing_material: null,
                        roof_color: this.cadRequestColorPers[item].roof ? this.cadRequestColorPers[item].roof['roof_color'] : null,
                    },
                spray_1f: {
                    exteriorRequestContent: this.cadRequestColorPers[item].spray_1f ? this.cadRequestColorPers[item].spray_1f['exteriorRequestContent'] : null,
                    },
                spray_2f: {
                    exteriorRequestContent: this.cadRequestColorPers[item].spray_2f ? this.cadRequestColorPers[item].spray_2f['exteriorRequestContent'] : null,
                    },
                spray_3f: {
                    exteriorRequestContent: this.cadRequestColorPers[item].spray_3f ? this.cadRequestColorPers[item].spray_3f['exteriorRequestContent'] : null,
                    },
                exterior_wall_tile : {
                    color_construction: null,
                    exterior_wall_tile: this.cadRequestColorPers[item].exterior_wall_tile ? this.cadRequestColorPers[item].exterior_wall_tile['exterior_wall_tile'] : null,
                    accent_wall_color: this.cadRequestColorPers[item].exterior_wall_tile ? this.cadRequestColorPers[item].exterior_wall_tile['accent_wall_color'] : null,
                    },
                external_wall_finish : this.cadRequestColorPers[item].external_wall_finish,
                balcony_glass : this.cadRequestColorPers[item].balcony_glass,
                design_louver : this.cadRequestColorPers[item].design_louver,
                sash : this.cadRequestColorPers[item].sash,
                front_door : {
                        entrance_door_type: null,
                        door_item: this.cadRequestColorPers[item].front_door ? this.cadRequestColorPers[item].front_door['door_item'] : null,
                        door_color: this.cadRequestColorPers[item].front_door ? this.cadRequestColorPers[item].front_door['door_color'] : null,
                    },
                mall_and_arrowhead_decoration : this.cadRequestColorPers[item].mall_and_arrowhead_decoration,
                balcony_belt : this.cadRequestColorPers[item].balcony_belt,
                tile_band : this.cadRequestColorPers[item].tile_band,
                decorative_belt_1f : this.cadRequestColorPers[item].decorative_belt_1f,
                decorative_belt_2f : this.cadRequestColorPers[item].decorative_belt_2f,
                eaves_of_a_house : this.cadRequestColorPers[item].eaves_of_a_house,
                eaves_gutter : this.cadRequestColorPers[item].eaves_gutter,
                breaking_wind : this.cadRequestColorPers[item].breaking_wind,
                base_draining : this.cadRequestColorPers[item].base_draining,
                porch_tile : {
                    porch_tile_item: this.cadRequestColorPers[item].porch_tile ? this.cadRequestColorPers[item].porch_tile['porch_tile_item'] : null,
                    porch_tile_item_color: this.cadRequestColorPers[item].porch_tile ? this.cadRequestColorPers[item].porch_tile['porch_tile_item_color'] : null,
                },
                perspective_direction : this.cadRequestColorPers[item].perspective_direction,
                viewpoint_height : this.cadRequestColorPers[item].viewpoint_height,
                garden_number : this.cadRequestColorPers[item].garden_number,
            }
            // this.cadRequestColorPers[this.newIndex] = color
            // this.previousColor = false;
            if(this.editMode) {
                this.editCadRequestColorPers[this.newIndex] = color
            } else {
                this.cadRequestColorPers[this.newIndex] = color
            }
            this.previousColor = false;
            // console.log(this.cadRequestColorPers[this.newIndex],'items')

        },
        copyToLatest(item){
            console.log(item,'fdf')
            let color = {
                is_request_color_info: item.is_request_color_info,
                roof: {
                        roofing_material: null,
                        roof_color: item.roof ? item.roof : null,
                    },
                spray_1f: {
                    exteriorRequestContent: item.spray_1f != null ? item.spray_1f : null,
                    },
                spray_2f: {
                    exteriorRequestContent: item.spray_2f != null ? item.spray_2f : null,
                    },
                spray_3f: {
                    exteriorRequestContent: item.spray_3f != null ? item.spray_3f : null,
                    },
                exterior_wall_tile : {
                    color_construction: null,
                    exterior_wall_tile: item.exterior_wall_tile ? item.exterior_wall_tile : null,
                    accent_wall_color: item.accent_wall_color ? item.accent_wall_color : null,
                    },
                external_wall_finish : item.external_wall_finish,
                balcony_glass : item.balcony_glass,
                design_louver : item.design_louver,
                sash : item.sash,
                front_door : {
                        entrance_door_type: null,
                        door_item: null,
                        door_color: item.front_door ? item.front_door : null,
                    },
                mall_and_arrowhead_decoration : item.mall_and_arrowhead_decoration,
                balcony_belt : item.balcony_belt,
                tile_band : item.tile_band,
                decorative_belt_1f : item.decorative_belt_1f,
                decorative_belt_2f : item.decorative_belt_2f,
                eaves_of_a_house : item.eaves_of_a_house,
                eaves_gutter : item.eaves_gutter,
                breaking_wind : item.breaking_wind,
                base_draining : item.base_draining,
                porch_tile : {
                    porch_tile_item: null,
                    porch_tile_item_color: item.porch_tile ? item.porch_tile : null,
                },
                perspective_direction : item.perspective_direction,
                viewpoint_height : item.viewpoint_height,
                garden_number : item.garden_number,
            }

            if(this.editMode) {
                this.editCadRequestColorPers[this.newIndex] = color
                this.previousColor = false;
            } else {
                this.cadRequestColorPers[this.newIndex] = color
                this.previousColor = false;
            }
            
        },

        resetColorpers(){
            if(this.editMode) this.$store.state.editCadRequestColorPers = [];
            else this.$store.state.cadRequestColorPers = [];
        },

        openDialogColorPers(){
            // this.dialogColorPers = true;
            // this.insertingColorPersContent();
            this.e6 = 3;
        },
        closeColorPers(val){
            this.dialogColorPers = val;
            this.requestPattern = null;
            this.e6 = 2
            if(this.editMode) this.$store.state.editCadRequestColorPers = [];
            else this.$store.state.cadRequestColorPers = [];
        },
        
        

        allEntranceDoorItem(){
            this.entranceDoorItem = []
            if(this.selectedEntranceDoor == '1'){

                let dataDoor = this.filterDoor.map((res) => {
                    // console.log(res.door_type,'door type')
                    return res;
                })
                // console.log(dataDoor,'data')
                dataDoor.forEach(element => {
                    if(element.door_type == 'PRONOVA (waku)') {
                        this.entranceDoorItem.push(element)
                    } else if(element.door_type == 'PRONOVA (jiku)'){
                        this.entranceDoorItem.push(element)
                    }
                });
            } else if(this.selectedEntranceDoor == '2'){

                let fanDoor = this.filterDoor.map((res) => {
                    return res;
                })

                fanDoor.forEach(fanElement => {
                    if(fanElement.door_type == 'FANOVA (waku)') {
                        this.entranceDoorItem.push(fanElement)
                    } else if(fanElement.door_type == 'FANOVA (jiku)') {
                        this.entranceDoorItem.push(fanElement)
                    }
                });
            } else if(this.selectedEntranceDoor == '3') {
                
                let waterDoor = this.filterDoor.map((res) => {
                    return res;
                })

                waterDoor.forEach(waterElement => {
                    if(waterElement.door_type == 'WATERTIGHT (waku)') {
                        this.entranceDoorItem.push(waterElement)
                    } else if(waterElement.door_type == 'WATERTIGHT (jiku)') {
                        this.entranceDoorItem.push(waterElement)
                    }
                });
            } else if(this.selectedEntranceDoor == '4'){

                let danjuuWater = this.filterDoor.map((res) => {
                    return res;
                })

                danjuuWater.forEach(danjuuElement => {
                    if(danjuuElement.door_type == 'DANNJU (waku)') {
                        this.entranceDoorItem.push(danjuuElement)
                    }
                });
            }
        },

        selectPorchColor(){
            // console.log(this.selectedPorchTile,'test')
            this.porchColor = []
            this.PORCH_TILES.map((res) => {
                // console.log(res,'res')
                if(res.name == this.selectedPorchTile && res.house_type_id == this.cadRequestBasicInformation.house_type_id){
                    this.porchColor = res.colors
                } 
            })



            // this.porcHouseType = []
            // let getPorchHouse = this.PORCH_TILES.map((res) => {
            //     // console.log(res,'res')
            //     return res;
            // })
            // getPorchHouse.forEach(element => {
            //     if(element.name == this.selectedPorchTile){
            //         this.porcHouseType.push(element.house_type)
            //     }
            // });     
        },

        colorTonesSelection() {
            // console.log(this.TILES,'LAHAT')
            this.toneColorSelection = []
            if(this.exteriorObj.toneSelection == '1'){
                this.exteriorObj.toneColorAccent = null
                // console.log('1 TONE')
                let data = this.filteredTiles.map((res) => {
                    // console.log(res,'Color Name')
                    if(res.tone == 1) return res.color
                    // else return;
                })

                data.forEach(element => {
                    if(element){
                        if(!element.includes(',') && !element.includes('+')){
                            this.toneColorSelection.push(element)
                        } 
                    }
                })
                // console.log(this.toneColorSelection,'ONE TONE')
            } else if(this.exteriorObj.toneSelection == '2') {
                let data2 = this.filteredTiles.map((res) => {
                    if(res.tone == 2) return res.color
                })

                data2.forEach(element2 => {
                    if(element2){
                        // if(element2.includes(',') || element2.includes('+')){
                        //     this.toneColorSelection.push(element2)
                        // }
                        if(!element2.includes(',') && !element2.includes('+')){
                            this.toneColorSelection.push(element2)
                        } 
                    }

                })
                // console.log(this.toneColorSelection, 'TWO TONE')
            }
        },


        editColorPers(){
            // console.log(this.cadRequestColorPers, "colorPers")
        },
        insertingColorPersContent(){
            let color_info = null;

            if(!this.$store.state.editMode){
                this.$store.state.cadRequestColorPers = [];
                // this.$store.state.cadRequestColorPers.splice(0);
                    let color_info = null;

                    if(this.$store.state.radio == '仕様書に従って作成'){
                        color_info = 0;
                    }else if(this.$store.state.radio == '色情報を指示して依頼'){
                        color_info = 1;
                    }
                    for (let i = 0; i < this.requestPattern; i++) {
                        let data ={
                            is_request_color_info: color_info,
                            roof: {
                                    roofing_material: null,
                                    roof_color: null,
                                },
                            spray_1f: {
                                exteriorRequestContent: null,
                                },
                            spray_2f: {
                                exteriorRequestContent: null,
                                },
                            spray_3f: {
                                exteriorRequestContent: null,
                                },
                            exterior_wall_tile : {
                                color_construction: null,
                                exterior_wall_tile: null,
                                accent_wall_color: null,
                                },
                            external_wall_finish : null,
                            balcony_glass : null,
                            design_louver : null,
                            sash : null,
                            front_door : {
                                entrance_door_type: null,
                                door_item: null,
                                door_color: null,
                                },
                            mall_and_arrowhead_decoration : null,
                            balcony_belt : null,
                            tile_band : null,
                            decorative_belt_1f : null,
                            decorative_belt_2f : null,
                            eaves_of_a_house : null,
                            eaves_gutter : null,
                            breaking_wind : null,
                            base_draining : null,
                            porch_tile : {
                                porch_tile_item: null,
                                porch_tile_item_color: null,
                            },
                            perspective_direction : null,
                            viewpoint_height : null,
                            garden_number : null,
                        }
                        this.$store.state.cadRequestColorPers.push(data)
                        data = {}
                    }

            }else{
                    // this.e6++; 
                    this.$store.state.editCadRequestColorPers.splice(0);

                    if(this.$store.state.radio == '仕様書に従って作成'){
                        color_info = 0;
                    }else if(this.$store.state.radio == '色情報を指示して依頼'){
                        color_info = 1;
                    }
                    for (let i = 0; i < this.requestPattern; i++) {
                        let data ={
                            is_request_color_info: color_info,
                            roof: {
                                    roofing_material: null,
                                    roof_color: null,
                                },
                            spray_1f: {
                                exteriorRequestContent: null,
                                },
                            spray_2f: {
                                exteriorRequestContent: null,
                                },
                            spray_3f: {
                                exteriorRequestContent: null,
                                },
                            exterior_wall_tile : {
                                color_construction: null,
                                exterior_wall_tile: null,
                                accent_wall_color: null,
                                },
                            external_wall_finish : null,
                            balcony_glass : null,
                            design_louver : null,
                            sash : null,
                            front_door : {
                                entrance_door_type: null,
                                door_item: null,
                                door_color: null,
                                },
                            mall_and_arrowhead_decoration : null,
                            balcony_belt : null,
                            tile_band : null,
                            decorative_belt_1f : null,
                            decorative_belt_2f : null,
                            eaves_of_a_house : null,
                            eaves_gutter : null,
                            breaking_wind : null,
                            base_draining : null,
                            porch_tile : {
                                porch_tile_item: null,
                                porch_tile_item_color: null,
                            },
                            perspective_direction : null,
                            viewpoint_height : null,
                            garden_number : null,
                        }
                        this.editCadRequestColorPers.push(data)
                        data = {}
                    }
                }
        },

        togglePorchTilesDialog(ii){
            this.curr_index = ii
            // console.log(this.curr_index, "curr")
            // console.log(this.PORCH_TILES, "PORCH_TILES")
            if( !this.PORCH_TILES.length ){
                console.log('Retrieving Data Please Wait')
                this._getPorchTiles()
                .then(() => {
                    console.log('Data Retrieved')
                    // let porch = []
                    // this.PORCH_TILES.filter((r) => {
                    //     porch.push(r.name)
                    // })
                    // this.PORCH_TILES = [... new Set(porch)]
                })
                .finally(() => this.dialogPorchTiles = true)
            }else{
                this.dialogPorchTiles = true;
            }       
        },

        StoreSiding1f(){
            if(!this.editMode){
                if(this.siding1F == "0"){
                    this.cadRequestColorPers[this.curr_index].spray_1f.exteriorRequestContent = null;
                }else{
                    this.cadRequestColorPers[this.curr_index].spray_1f.exteriorRequestContent = this.sidingSelection
                }
                    this.dialogSiding1F = false;
            }else{
                if(this.siding1F == "0"){
                    this.editCadRequestColorPers[this.curr_index].spray_1f.exteriorRequestContent = null;
                }else{
                    this.editCadRequestColorPers[this.curr_index].spray_1f.exteriorRequestContent = this.sidingSelection
                }
                    this.dialogSiding1F = false;
            }
        },
        StoreSiding2f(){
            if(!this.editMode){
                if(this.siding2F == "0"){
                    this.cadRequestColorPers[this.curr_index].spray_2f.exteriorRequestContent = null;
                }else{
                    this.cadRequestColorPers[this.curr_index].spray_2f.exteriorRequestContent = this.sidingSelection
                }
                    this.dialogSiding2F = false;
            }else{
                if(this.siding2F == "0"){
                    this.editCadRequestColorPers[this.curr_index].spray_2f.exteriorRequestContent = null;
                }else{
                    this.editCadRequestColorPers[this.curr_index].spray_2f.exteriorRequestContent = this.sidingSelection
                }
                    this.dialogSiding2F = false;
            }
        },
        StoreSiding3f(){
            if(!this.editMode){
                if(this.siding3F == "0"){
                    this.cadRequestColorPers[this.curr_index].spray_3f.exteriorRequestContent = null;
                }else{
                    this.cadRequestColorPers[this.curr_index].spray_3f.exteriorRequestContent = this.sidingSelection
                }
                    this.dialogSiding3F = false;
            }else{
                if(this.siding3F == "0"){
                    this.editCadRequestColorPers[this.curr_index].spray_3f.exteriorRequestContent = null;
                }else{
                    this.editCadRequestColorPers[this.curr_index].spray_3f.exteriorRequestContent = this.sidingSelection
                }
                    this.dialogSiding3F = false;
            }
        },
        closeDialog(){
            this.dialogExteriorRequestContent = false;
        },

        StoreRoof(){
            if(this.$refs.StoreRoof.validate()){
                // console.log(this.colorPersIndex, "index")
                // const myForm = document.getElementById('StoreRoof')
                // const formdata = new FormData(myForm);

                if(!this.editMode){
                    this.cadRequestColorPers[this.colorPersIndex].roof.roofing_material = this.selectedRoof
                    this.cadRequestColorPers[this.colorPersIndex].roof.roof_color = this.roofColor
                    this.dialogRoof = false;
                }else{
                    this.editCadRequestColorPers[this.colorPersIndex].roof.roofing_material = this.selectedRoof
                    this.editCadRequestColorPers[this.colorPersIndex].roof.roof_color = this.roofColor
                    this.dialogRoof = false;
                }

            }
            // console.log(this.cadRequestColorPers)
        },

        StoreExteriorWallTiles(item){
            // console.log(item, 'item')
            if(!this.editMode){
                this.cadRequestColorPers[this.colorPersIndex].exterior_wall_tile = {
                                                                                        color_construction: item.toneSelection,
                                                                                        exterior_wall_tile: item.toneColor ? item.toneColor : null,
                                                                                        accent_wall_color: item.toneColorAccent,
                                                                                    }
            }else{
                    this.editCadRequestColorPers[this.colorPersIndex].exterior_wall_tile = {
                                                                                color_construction: item.toneSelection,
                                                                                exterior_wall_tile: item.toneColor ? item.toneColor : null,
                                                                                accent_wall_color: item.toneColorAccent,
                                                                            }
                    // console.log(this.editCadRequestColorPers[this.colorPersIndex].exterior_wall_tile, 'this.editCadRequestColorPers[index] XYZ')
            }
            this.dialogExteriorWallTiles = false
            // console.log(this.cadRequestColorPers[this.colorPersIndex], 'colorpers')
            // console.log(this.editCadRequestColorPers[this.colorPersIndex], 'edit colorpers')

        },
        StoreGarden(ii){
            if(!this.editMode) this.cadRequestColorPers[ii].garden_number = this.gardenSelection
            else this.editCadRequestColorPers[ii].garden_number = this.gardenSelection
            // console.log(this.cadRequestColorPers, 'cadreq')
        },

        toggleDialogEntranceDoor(index){
            this.curr_index = index
            if( !this.ENTRANCE_DOORS.length ){
                console.log('Retrieving Data Please Wait')
                this._getEntranceDoors()
                .then(() => {
                    console.log('Data Retrieved')
                })
                .finally(() => this.dialogEntranceDoor = true)
            }else{
                this.dialogEntranceDoor = true;
            }
        },

        toggleDialogDesignLouvers(index){
            this.curr_index = index;
            this.dialogDesignLouver = true
        },

        toggleDialogExteriorWallTiles(index){
            this.colorPersIndex = index
            this.dialogExteriorWallTiles = true
            if(!this.editMode){
                this.exteriorObj.toneSelection = this.cadRequestColorPers[index].exterior_wall_tile.color_construction;
                this.exteriorObj.toneColor = this.cadRequestColorPers[index].exterior_wall_tile ? this.cadRequestColorPers[index].exterior_wall_tile.exterior_wall_tile : null;
                this.exteriorObj.toneColorAccent = this.cadRequestColorPers[index].exterior_wall_tile ? this.cadRequestColorPers[index].exterior_wall_tile.accent_wall_color : null;
            }else{
                // console.log(this.editCadRequestColorPers[index], 'this.editCadRequestColorPers[index]')
                this.exteriorObj.toneSelection = this.editCadRequestColorPers[index].exterior_wall_tile.color_construction;
                this.exteriorObj.toneColor = this.editCadRequestColorPers[index].exterior_wall_tile ? this.editCadRequestColorPers[index].exterior_wall_tile.exterior_wall_tile : null;
                this.exteriorObj.toneColorAccent = this.editCadRequestColorPers[index].exterior_wall_tile ? this.editCadRequestColorPers[index].exterior_wall_tile.accent_wall_color : null;
            }

            // this.cadRequestColorPers[this.colorPersIndex].exterior_wall_tile = {
            //                                                                     color_construction: item.toneSelection,
            //                                                                     exterior_wall_tile: item.toneColor,
            //                                                                     accent_wall_color: item.toneColorAccent,
            //                                                                 }
            

        },

        toggleDialogExteriorRequestContent(vModel){
            // console.log(vModel,this[vModel]);
            this.activeSidingDropdown = this[vModel];
            this.dialogExteriorRequestContent = true;
        },

        toggleOpenSidingDialog(value, index){
            switch (value) {
                case 'dialogSiding3F':
                case 'dialogSiding2F':
                case 'dialogSiding1F':
                    this[value] = true;
                    break;
            
                default:
                    break;
            }
            this.curr_index = index;
        },

        toggleCloseSidingDialog(value){
            switch (value) {
                case 'dialogSiding3F':
                case 'dialogSiding2F':
                case 'dialogSiding1F':
                    this[value] = false;
                    break;
            
                default:
                    break;
            }
        },

        toggleDialogColorPerspective(value){
            // if(value == false){
            //     console.log('testtttttt')
            //     this.$store.state.cadRequestColorPers = [];
            //     this.radio = null
            //     this.requestPattern = 0
            //     this.e6 = 1
            // }
            if(this.editMode) {
                this.$emit('toggleDialogColorPerspective', value)
            }else{
                this.$store.state.cadRequestColorPers = [];
                this.$store.state.radio = 1;
                this.requestPattern = 0;
                this.$emit('toggleDialogColorPerspective', value)
            }
            if(!value){
                if(this.editMode) this.$store.state.editCadRequestRevisionContent.color_pers = 0;
                else this.$store.state.cadRequestRevisionContent.color_pers = 0;
            }

        },

        toggleRoofDialog(index){
            if(this.ROOF_SELECTION.length == 0){
                this._getRoofSelection()
                    .then(() => this.dialogRoof = true)
                    .finally(() => { return });
            }

            this.dialogRoof = true
            this.colorPersIndex = index
            // console.log(this.colorPersIndex)
            return
        },

        test(){
            alert('test');
        }, 
        setBalconyGlass(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].balcony_glass = item
            else this.editCadRequestColorPers[index].balcony_glass = item
            // console.log(index)
            // console.log(this.cadRequestColorPers ," this.cadRequestColorPers")
            // this.cadRequestColorPers[index].balcony_glass = this.balconyGlassSelection
            // console.log(item)
        },
        storeDesignLouver(){
            if(!this.editMode) this.cadRequestColorPers[this.curr_index].design_louver = this.design_louver_item
            else this.editCadRequestColorPers[this.curr_index].design_louver = this.design_louver_item
            this.dialogDesignLouver = false
        },
        storeEntranceDoor(){
            if (!this.editMode){
                this.cadRequestColorPers[this.curr_index].front_door.entrance_door_type = this.selectedEntranceDoor
                this.cadRequestColorPers[this.curr_index].front_door.door_item = this.doorItem
                this.cadRequestColorPers[this.curr_index].front_door.door_color = this.doorColor
            }else{
                this.editCadRequestColorPers[this.curr_index].front_door.entrance_door_type = this.selectedEntranceDoor
                this.editCadRequestColorPers[this.curr_index].front_door.door_item = this.doorItem
                this.editCadRequestColorPers[this.curr_index].front_door.door_color = this.doorColor
            }
            this.dialogEntranceDoor = false

            // console.log(this.cadRequestColorPers)
        },
        setColorPersSash(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].sash = item
            else this.editCadRequestColorPers[index].sash = item
        },
        setColorPersEaves(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].eaves_of_a_house = item
            else this.editCadRequestColorPers[index].eaves_of_a_house = item
        },
        setColorPersEavesGutter(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].eaves_gutter = item
            else this.editCadRequestColorPers[index].eaves_gutter = item
        },
        setColorPersBreaking_wind(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].breaking_wind = item
            else this.editCadRequestColorPers[index].breaking_wind = item
        },
        setColorPersBase_draining(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].base_draining = item
            else this.editCadRequestColorPers[index].base_draining = item
        },
        setColorPersPerspective_direction(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].perspective_direction = item
            else this.editCadRequestColorPers[index].perspective_direction = item
        },
        setColorPersViewpoint_height(index, item){
            if (!this.editMode) this.cadRequestColorPers[index].viewpoint_height = item
            else this.editCadRequestColorPers[index].viewpoint_height = item
        },
        setTileExternal(index,item){
            if(!this.editMode) this.cadRequestColorPers[index].external_wall_finish = item
            else this.editCadRequestColorPers[index].external_wall_finish = item
        },
        storePorch(item, color){
            if (!this.editMode){
                this.cadRequestColorPers[this.curr_index].porch_tile.porch_tile_item = this.selectedPorchTile
                this.cadRequestColorPers[this.curr_index].porch_tile.porch_tile_item_color = this.porch_color
            }else{
                this.editCadRequestColorPers[this.curr_index].porch_tile.porch_tile_item = this.selectedPorchTile
                this.editCadRequestColorPers[this.curr_index].porch_tile.porch_tile_item_color = this.porch_color
            }
            this.dialogPorchTiles = false
            // console.log(this.cadRequestColorPers[this.curr_index], "color")
        },

        storeColorPers(){
            if(!this.$store.state.editMode){
                this.$store.state.cadRequestRevisionContent.color_pers = 1;
                this.$store.state.hideColorPersTable = this.cadRequestColorPers[0].is_request_color_info;
            }
            else{
                this.$store.state.editCadRequestRevisionContent.color_pers = 1;
                this.$store.state.hideColorPersTable = this.editCadRequestColorPers[0].is_request_color_info;
            }
                this.$emit('toggleDialogColorPerspective', false);
                this.$store.state.radio = 1;
                this.dialogColorPers = false;

        },
        proceedToNext(){
            // console.log(this.radio,'radio')
            if(this.$store.state.radio == '依頼なし'){
                this.noRequestColor = true;
                // let ans = confirm('依頼はなしで良いでしょうか。');
                // if(ans){
                //     axios({
                //         method : "POST",
                //         url : "api/color_pers/delete_colorpers",
                //         data : {
                //             basicInformation: this.$store.state.cadRequestBasicInformation,
                //             latestRevision: this.$store.state.cadRequestLatestRevision,
                //         }
                //     }).then((res) => {
                //         this.toggleDialogColorPerspective(false)
                //         if(!this.editMode){
                //             this.$store.state.cadRequestRevisionContent.color_pers = null;
                //             this.$store.state.cadRequestColorPers = [];
                //         }else{
                //             this.$store.state.editCadRequestRevisionContent.color_pers = null;
                //             this.$store.state.editCadRequestColorPers = [];
                //         }
                //     })
                // } else {
                //     this.$store.state.radio = null;
                // }
            }else{
                this.e6++;
                this.requestPattern = 0;
            }
            // console.log(this.$store.state.cadRequestRevisionContent, this.e6, 'cadRequestRevisionContent dialog')
        },

        acceptNoRequestColors(){
            axios({
                method : "POST",
                url : "api/color_pers/delete_colorpers",
                data : {
                    basicInformation: this.$store.state.cadRequestBasicInformation,
                    latestRevision: this.$store.state.cadRequestLatestRevision,
                }
            }).then((res) => {
                this.toggleDialogColorPerspective(false)
                if(!this.editMode){
                    this.$store.state.cadRequestRevisionContent.color_pers = null;
                    // this.$store.state.cadRequestColorPers = [];
                }else{
                    this.$store.state.editCadRequestRevisionContent.color_pers = null;
                    this.$store.state.editCadRequestColorPers = [];
                }
                this.closeNoRequestColors();
            })
        },
        closeNoRequestColors(){
            this.noRequestColor = false;
            this.$store.state.radio = null;
        },

        validateColorPers(){
            for (let i = 0; i < array.length; i++) {
                const element = array[i];
                
            }
        },
        storeData(){
            
            // console.log(this.patterns,this.cadRequestColorPers, "patternspatternspatternspatterns")
            if(this.$store.state.editMode){
                for (let i = 0; i < this.editCadRequestColorPers.length; i++) {
                    if(this.patterns[i+1].direction && this.patterns[i+1].height){
                        this.editCadRequestColorPers[i].perspective_direction = this.patterns[i+1].direction;
                        this.editCadRequestColorPers[i].viewpoint_height = this.patterns[i+1].height;
                        // console.log('edit mode')
                    }else{
                        alert('Please fill out all fields!')
                        return false;
                    }
                }
                // console.log(this.editCadRequestColorPers, "editssss")
            }else {
                for (let i = 0; i < this.cadRequestColorPers.length; i++) {
                    if(this.patterns[i+1].direction && this.patterns[i+1].height){
                        this.cadRequestColorPers[i].perspective_direction = this.patterns[i+1].direction;
                        this.cadRequestColorPers[i].viewpoint_height = this.patterns[i+1].height;
                    }else{
                        alert('Please fill out all fields!')
                        return false;
                    }
                }
            }
            this.storeColorPers()
        },
        // color_perspective(){
        //     this.$emit('color_perspective', this.cadRequestColorPers)
        //     this.toggleDialogColorPerspective(false)
        // },
        colorPerHouseType(){
            // console.log(this.TILES,'CAD')
            // console.log(this.cadRequestBasicInformation.house_type_id,'this.cadRequestBasicInformation.house_type_id')


            this.filterPorchTile = []
            let v = []
            this.PORCH_TILES.filter((res) => {
                    // console.log(res,'res')
                    v.push(res.name);
            })
            this.filterPorchTile = [...new Set(v)]
            // console.log(this.filterPorchTile,'sss')

            
            this.filteredTiles = [] 
            this.TILES.map((res) => {
                if(res.house_types.length > 0){
                    res.house_types.forEach(element => {
                        if(element.house_type_id == this.cadRequestBasicInformation.house_type_id) {
                            this.filteredTiles.push(res);
                            // console.log(element,'filter')
                            // return res
                        }
                    });
                }
            })

            // PRONOVA ENTRANCE DOOR
            this.filterDoor = []
            this.ENTRANCE_DOORS.map((res) => {
                if(res.entrancehouse.length > 0) {
                    res.entrancehouse.forEach(element => {
                        if(element.house_type_id == this.cadRequestBasicInformation.house_type_id){
                            this.filterDoor.push(res);
                        }
                    });
                }
            })

        },

    },

    watch: {
        "$store.state.existingRevisions"(val){
            this.existingColorPers = [];
            if(val){
                val.filter((res) => {
                    if(res.color_perspective.length > 0){
                        // this.existingColorPers.push(res.color_perspective);
                        res.color_perspective.map(element => {
                            if(element){
                                if(element.is_request_color_info == '1'){
                                    element.temp_created = moment(element.created_at).format("MM/DD")
                                    element.house_type_id = parseInt(element.house_type_id)
                                    // return element;
                                    this.existingColorPers.push(element)
                                }
                            }
                            // this.existingColorPers = this.existingColorPers.map((r) => {
                            //     r.temp_created = moment(r.created_at).format("MM/DD")
                            //     return r;
                            // })
                        });
                        // console.log(this.existingColorPers)
                        // this.existingColorPers.push(color_pers)
                    }
                })
            }
        },
        // colorPers(val){
        //     if(val){
        //         this.$emit("emmitedColor",this.cadRequestColorPers)
        //         this.editColorPers();
        //     }
        // },
        // '$store.state.cadRequestColorPers'(val){
        //     console.log(val, "watch color");
        // },
        dialog(val) {
            // console.log(val, this.$store.state.editCadRequestColorPers, "editCadRequestColorPers")
            if(!val){
                this.patterns[1].direction = null
                this.patterns[1].height = null

                this.patterns[2].direction = null
                this.patterns[2].height = null

                this.patterns[3].direction = null
                this.patterns[3].height = null

                this.patterns[4].direction = null
                this.patterns[4].height = null

                // this.$store.state.radio = null
                this.requestPattern = 0
                this.e6 = 1
            }else{
                this.colorPerHouseType();
                if(this.cadRequestColorPers){
                    if(this.cadRequestColorPers.length != 0){
                        // console.log(this.cadRequestColorPers, "watchhhhh")
                        // console.log(this.cadRequestColorPers,"colorpers");
                        // this.radio = this.$store.state.storeRequestContents.filter(rec=> rec.value == this.cadRequestColorPers[0].is_request_color_info + 1)[0].text 
                        this.$store.state.radio = this.requestContents.filter(rec=> rec.value == this.cadRequestColorPers[0].is_request_color_info + 1)[0].text 
                        this.requestPattern = this.cadRequestColorPers.length

                        if(this.$store.state.radio == '仕様書に従って作成'){
                            this.e6++;
                            if(this.requestPattern){
                                this.e6++
                                for (let i = 1; i <= this.cadRequestColorPers.length; i++) {
                                    this.patterns[i].height = this.cadRequestColorPers[i-1].viewpoint_height;
                                    this.patterns[i].direction = this.cadRequestColorPers[i-1].perspective_direction;
                                }
                            }
                        }else{
                            this.e6++;
                            if(this.requestPattern){
                                this.dialogColorPers = true;
                            }
                        }
                    }
                }
                if(this.$store.state.editCadRequestColorPers){
                    if(this.$store.state.editCadRequestColorPers.length != 0){
                        // console.log(this.cadRequestColorPers,"colorpers");
                        this.$store.state.radio = this.requestContents.filter(rec=> rec.value == this.editCadRequestColorPers[0].is_request_color_info + 1)[0].text 
                        this.requestPattern = this.editCadRequestColorPers.length

                        if(this.$store.state.radio == '仕様書に従って作成'){
                            this.e6++;
                            if(this.requestPattern){
                                this.e6++
                                // console.log(this.e6)
                                for (let i = 1; i <= this.editCadRequestColorPers.length; i++) {
                                    this.patterns[i].height = this.editCadRequestColorPers[i-1].viewpoint_height;
                                    this.patterns[i].direction = this.editCadRequestColorPers[i-1].perspective_direction;
                                }
                            }
                        }else{
                            this.e6++;
                            // if(this.requestPattern){
                                // this.editCadRequestColorPers[ii].spray_1f.exteriorRequestContent
                                // console.log(this.editCadRequestColorPers, this.requestPattern, 'watch')
                                // let tempEdit = [];
                                // for (let i = 0; i < this.editCadRequestColorPers.length; i++) {
                                //     // this.editCadRequestColorPers[i] = {...this.editCadRequestColorPers[i]}
                                //     let data = {
                                //         is_request_color_info: this.editCadRequestColorPers[i].is_request_color_info,
                                //         roof: {
                                //                 roofing_material: null,
                                //                 roof_color: null,
                                //             },
                                //         spray_1f: {
                                //             exteriorRequestContent: this.editCadRequestColorPers[i].spray_1f,
                                //             },
                                //         spray_2f: {
                                //             exteriorRequestContent: this.editCadRequestColorPers[i].spray_2f,
                                //             },
                                //         spray_3f: {
                                //             exteriorRequestContent: this.editCadRequestColorPers[i].spray_3f,
                                //             },
                                //         exterior_wall_tile : {
                                //             color_construction: null,
                                //             exterior_wall_tile: this.editCadRequestColorPers[i].exterior_wall_tile,
                                //             accent_wall_color: this.editCadRequestColorPers[i].accent_wall_color,
                                //             },
                                //         balcony_glass : this.editCadRequestColorPers[i].balcony_glass,
                                //         design_louver : this.editCadRequestColorPers[i].design_louver,
                                //         sash : this.editCadRequestColorPers[i].sash,
                                //         front_door : {
                                //             entrance_door_type: null,
                                //             door_item: null,
                                //             door_color: null,
                                //             },
                                //         mall_and_arrowhead_decoration : this.editCadRequestColorPers[i].mall_and_arrowhead_decoration,
                                //         balcony_belt : this.editCadRequestColorPers[i].balcony_belt,
                                //         tile_band : this.editCadRequestColorPers[i].tile_band,
                                //         decorative_belt_1f : this.editCadRequestColorPers[i].decorative_belt_1f,
                                //         decorative_belt_2f : this.editCadRequestColorPers[i].decorative_belt_2f,
                                //         eaves_of_a_house : this.editCadRequestColorPers[i].eaves_of_a_house,
                                //          eaves_gutter : this.editCadRequestColorPers[i].eaves_gutter,
                                //         breaking_wind : this.editCadRequestColorPers[i].breaking_wind,
                                //         base_draining : this.editCadRequestColorPers[i].base_draining,
                                //         porch_tile : {
                                //             porch_tile_item: null,
                                //             porch_tile_item_color: this.editCadRequestColorPers[i].porch_tile,
                                //         },
                                //         perspective_direction : this.editCadRequestColorPers[i].perspective_direction,
                                //         viewpoint_height : this.editCadRequestColorPers[i].viewpoint_height,
                                //         garden_number : this.editCadRequestColorPers[i].garden_number,
                                //     }
                                //     tempEdit.push(data)

                                // }
                                    // console.log(tempEdit, "tempedit")

                                // this.$store.state.editCadRequestColorPers = [];
                                // this.$store.state.editCadRequestColorPers = tempEdit;
                                // console.log(this.$store.state.editCadRequestColorPers, "test watch")
                                this.dialogColorPers = true;

                            // }
                        }
                    }
                }
            }
        },

        dialogRoof(val){
            if(!val){
                this.$refs.StoreRoof.reset();
            }
        }, 

        dialogSiding1F(val){
            if(!val){
                this.siding1F = undefined;
                this.$refs.StoreSiding1f.reset();
            }
        }, 
        // dialogSiding2F(val){
        //     if(!val){
        //         this.siding2F = undefined;
        //         this.$refs.StoreSiding2f.reset();
        //     }
        // }, 
        // dialogSiding3F(val){
        //     if(!val){
        //         this.siding3F = undefined;
        //         this.$refs.StoreSiding3f.reset();
        //     }
        // }, 
    },


    mounted(){
            this.allEntranceDoorItem();
            this._getLenaRack()
            this._getSprayShipo()
            this._getSpraySynagio()
            this._getCombDesigns()
            this._getSiporoks()
            this._getLouverItems()
            this._getLouverWoods()
            this._getLouverPaints()
            this._getEavesSelections()
            this._getGableSelections()
            this._getBaseDrainers()
            this._getViewDirectionSelections()
            this._getViewHeightSelections()
            this._getTiles()
            this._getEntranceDoors()
            this._getBalconyBeltMakeupTiles()
            this._getMoldingSelection()
            this._getPorchTiles()
            this._getSashSelection()
            this._getSprayItems()
            this._getEavesGutterSelections()
            this._getTileExternal()
        
        // this.allEntranceDoorItem();
        //     this._getLenaRack() .then(() => {
        //     this._getSprayShipo() .then(() => {
        //         this._getSpraySynagio() .then(() => {
        //             this._getCombDesigns() .then(() => {
        //                 this._getSiporoks() .then(() => {
        //                     this._getLouverItems() .then(() => {
        //                         this._getLouverWoods() .then(() => {
        //                             this._getLouverPaints() .then(() => {
        //                                 this._getEavesSelections() .then(() => {
        //                                     this._getGableSelections() .then(() => {
        //                                         this._getBaseDrainers() .then(() => {
        //                                             this._getViewDirectionSelections().then( () => {
        //                                                 this._getViewHeightSelections(). then(() => {
        //                                                     this._getTiles().then (() => {
        //                                                         this._getEntranceDoors().then (() => {
        //                                                             this._getBalconyBeltMakeupTiles().then(() => {
        //                                                                 this._getMoldingSelection().then (() => {
        //                                                                     this._getPorchTiles().then( () => {
        //                                                                         this._getSashSelection().then( () => {
        //                                                                             this._getSprayItems().then(() => {
        //                                                                                 this._getEavesGutterSelections().then(() => {
        //                                                                                     this._getTileExternal().then(() => {
                                                                                                
        //                                                                                     })
        //                                                                                 })
        //                                                                             })
        //                                                                         })
        //                                                                     })
        //                                                                 })
        //                                                             })
        //                                                         })
        //                                                     })
        //                                                 })
        //                                             })
        //                                         })
        //                                     })
        //                                 })
        //                             })
        //                         })
        //                     })
        //                 })
        //             })
        //         })
        //     })
        // })
    }
}
</script>

<style scoped>
    .v-data-table.colorView th {
        border: 1px solid black;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
        border-bottom: 1px solid black !important;
    }

     .v-data-table.colorView td {
        border-bottom: 1px solid white !important;
    }

     .v-data-table.requestView td {
        border-top: 1px solid black ;
        border-right: 1px solid black !important;
        border-left: 1px solid black !important;
    }
    
    .left-sticky {
        width: 100px !important;
        position: sticky;
        left: 0;
        z-index: 1;
        border-top: 1px solid black !important;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
    }

    .existing-request{
        background: #d1d4d1!important;
        color: black!important;
        border-top: 1px solid black !important;
        border-right: 1px solid black !important;
    }
    .req-divider{
        border-top: 1px solid black !important;
        background: #D3D3D3!important;
        width: 5px !important;
    }

    /* CASE WHEN REQUEST PATTERN == 4 */
    .pattern-4-1{
        min-width: 200px !important;
        position: sticky;
        right: 600px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;

    }
    .pattern-4-2{
        min-width: 200px !important;
        position: sticky;
        right: 400px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-4-3{
        min-width: 200px !important;
        position: sticky;
        right: 200px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-4-4{
        min-width: 200px !important;
        position: sticky;
        right: 0px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    /* CASE WHEN REQUEST PATTERN == 3 */
    .pattern-3-1{
        min-width: 200px !important;
        position: sticky;
        right: 400px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-3-2{
        min-width: 200px !important;
        position: sticky;
        right: 200px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-3-3{
        min-width: 200px !important;
        position: sticky;
        right: 0;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    /* CASE WHEN REQUEST PATTERN == 2 */
    .pattern-2-1{
        min-width: 200px !important;
        position: sticky;
        right: 200px;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }
    .pattern-2-2{
        min-width: 200px !important;
        position: sticky;
        right: 0;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    /* CASE WHEN REQUEST PATTERN == 1 */
    .pattern-1-1{
        min-width: 200px !important;
        position: sticky;
        right: 0;
        z-index: 1;
        background: whitesmoke;
        color: black!important;
        border-bottom-color: black !important;
    }

    .top-sticky {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    /*  */
    .image-header-sticky{
        position: sticky;
        top: 1px !important;
        left: 98px !important;
        z-index: 2 !important;
        background: #d1d4d1;
        border-left-color: black !important;
        border-right-color: black !important;
    }
</style>
